const RAW_BUNDLE_API_BASE = (window.__BUNDLE_API_BASE || '').replace(/\/$/, '');
const BUNDLE_API_BASE =
  window.location?.protocol === 'https:' && RAW_BUNDLE_API_BASE.startsWith('http://')
    ? RAW_BUNDLE_API_BASE.replace(/^http:\/\//, 'https://')
    : RAW_BUNDLE_API_BASE;
const buildBundleApiUrl = (path) => {
  const normalizedPath = path?.startsWith('/') ? path : `/${path || ''}`;
  if (!BUNDLE_API_BASE) {
    return normalizedPath;
  }
  try {
    return new URL(normalizedPath, BUNDLE_API_BASE).toString();
  } catch (error) {
    console.warn('Invalid bundle API base, falling back to relative path', error);
    return normalizedPath;
  }
};

const bundleProductCache = new Map();

/* ============================================
   Cute Modal Helpers (replaces native alerts)
   ============================================ */
function showAppModal({ title = 'Heads up', message = '', confirmText = 'OK', cancelText = 'Cancel', showCancel = false } = {}) {
  return new Promise((resolve) => {
    const bodyDataset = document.body ? document.body.dataset : {};
    const titleText = title || bodyDataset.modalTitle || 'Heads up';
    const confirm = confirmText || bodyDataset.modalOk || 'OK';
    const cancel = cancelText || bodyDataset.modalCancel || 'Cancel';

    const existing = document.getElementById('tm-modal');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'tm-modal';
    overlay.className = 'tm-modal';

    const modal = document.createElement('div');
    modal.className = 'tm-modal__content';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'tm-modal__close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.textContent = '×';

    const titleEl = document.createElement('p');
    titleEl.className = 'tm-modal__title';
    titleEl.textContent = titleText;

    const messageEl = document.createElement('p');
    messageEl.className = 'tm-modal__message';
    messageEl.textContent = message;

    const actions = document.createElement('div');
    actions.className = 'tm-modal__actions';

    const primary = document.createElement('button');
    primary.type = 'button';
    primary.className = 'tm-modal__button';
    primary.textContent = confirm;

    const secondary = document.createElement('button');
    secondary.type = 'button';
    secondary.className = 'tm-modal__button tm-modal__button--ghost';
    secondary.textContent = cancel;

    const cleanup = (result) => {
      overlay.remove();
      document.removeEventListener('keydown', onKeydown);
      resolve(result);
    };

    const onKeydown = (event) => {
      if (event.key === 'Escape') {
        cleanup(false);
      }
    };

    primary.addEventListener('click', () => cleanup(true));
    secondary.addEventListener('click', () => cleanup(false));
    closeBtn.addEventListener('click', () => cleanup(false));
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) cleanup(false);
    });

    actions.appendChild(primary);
    if (showCancel) {
      actions.appendChild(secondary);
    }

    modal.appendChild(closeBtn);
    modal.appendChild(titleEl);
    modal.appendChild(messageEl);
    modal.appendChild(actions);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    primary.focus();
    document.addEventListener('keydown', onKeydown);
  });
}

function appAlert(message, options = {}) {
  return showAppModal({
    title: options.title || 'Just a heads up',
    message: message || '',
    confirmText: options.confirmText || 'Got it',
    showCancel: false
  });
}

function appConfirm(message, options = {}) {
  return showAppModal({
    title: options.title || (document.body?.dataset?.modalTitle) || 'Heads up',
    message: message || '',
    confirmText: options.confirmText || (document.body?.dataset?.modalOk) || 'OK',
    cancelText: options.cancelText || (document.body?.dataset?.modalCancel) || 'Cancel',
    showCancel: true
  });
}

// Expose globally to replace native alerts/confirm
window.appAlert = appAlert;
window.alert = appAlert;
window.appConfirm = appConfirm;
window.confirm = (message) => {
  appConfirm(message);
  return false;
};

function getAlertText(dataKey, fallback) {
  return (document.body && document.body.dataset[dataKey]) || fallback;
}

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const siteNav = document.querySelector('.site-nav');
  const heroNavLeft = document.querySelector('.hero__nav-left');
  const heroUnderline = heroNavLeft && heroNavLeft.querySelector('.hero__underline');
  const heroLinks = heroNavLeft ? heroNavLeft.querySelectorAll('.hero__link') : [];
  const heroVideo = document.querySelector('[data-hero-video]');

  if (heroVideo) {
    const heroSection = heroVideo.closest('.product-page__hero');
    let heroLoaded = false;
    const markLoaded = () => {
      if (heroLoaded) return;
      heroLoaded = true;
      heroSection?.classList.remove('is-loading');
      document.body.classList.remove('page-loading');
    };
    const tryMarkImmediately = () => {
      if (!heroVideo) return;
      // If the video is already ready or playing, drop the loader.
      if (heroVideo.readyState >= 2 || (!heroVideo.paused && !heroVideo.ended)) {
        markLoaded();
      }
    };
    document.body.classList.add('page-loading');
    heroSection?.classList.add('is-loading');
    ['loadeddata', 'canplay', 'playing', 'loadedmetadata', 'play', 'timeupdate'].forEach((ev) =>
      heroVideo.addEventListener(ev, markLoaded, { once: true })
    );
    heroVideo.addEventListener('error', markLoaded, { once: true });
    heroVideo.addEventListener('stalled', markLoaded, { once: true });
    // Catch the case where events fired before listeners were attached
    setTimeout(tryMarkImmediately, 200);
    // Absolute max wait before hiding loader
    setTimeout(markLoaded, 8000);
  }


  function updateHeroUnderline(targetLink) {
    if (!heroNavLeft || !heroUnderline) return;
    if (!targetLink) {
      heroUnderline.style.display = 'none';
      return;
    }
    const navRect = heroNavLeft.getBoundingClientRect();
    const linkRect = targetLink.getBoundingClientRect();
    heroUnderline.style.width = `${linkRect.width}px`;
    heroUnderline.style.left = `${linkRect.left - navRect.left}px`;
    heroUnderline.style.display = 'block';
  }

  function activateLink(link) {
    if (!link) return;
    heroLinks.forEach(l => l.classList.remove('hero__link--active'));
    link.classList.add('hero__link--active');
    updateHeroUnderline(link);
    localStorage.setItem('heroActiveLink', link.getAttribute('href') || '');
  }

  if (heroLinks.length > 0) {
    const currentPath = window.location.pathname;
    const stored = localStorage.getItem('heroActiveLink');
    const matchingLink =
      heroNavLeft.querySelector('.hero__link--active') ||
      Array.from(heroLinks).find(link => {
        if (!link.href) {
          return false;
        }
        const linkPath = new URL(link.href, window.location.origin).pathname;
        return linkPath === currentPath || currentPath.startsWith(linkPath);
      }) ||
      Array.from(heroLinks).find(link => stored && link.getAttribute('href') === stored);
    const initialActive = matchingLink || heroLinks[0];
    activateLink(initialActive);
  }

  heroLinks.forEach(link => {
    link.addEventListener('click', function() {
      activateLink(this);
      if (siteNav && siteNav.classList.contains('menu-open') && menuToggle) {
        menuToggle.click();
      }
    });
  });

  window.addEventListener('resize', () => {
    const active = heroNavLeft?.querySelector('.hero__link--active');
    updateHeroUnderline(active);
  });
  
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      siteNav.classList.toggle('menu-open');
      document.body.classList.toggle('menu-open');
    });
  }
  
  // Header background on scroll
  const header = document.querySelector('header');
  let lastScrollTop = 0;
  
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // Add white background when scrolled past a threshold (e.g., 50px)
    if (scrollTop > 50) {
      header.classList.add('scrolled');
      document.body && document.body.classList.add('header-scrolled');
    } else {
      header.classList.remove('scrolled');
      document.body && document.body.classList.remove('header-scrolled');
    }
    
    lastScrollTop = scrollTop;
  }
  
  // Throttle scroll events for better performance
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        handleScroll();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Check initial scroll position
  handleScroll();

  // Collection product cards: cycle through all media on hover (carousel mode)
  const cardMediaEls = document.querySelectorAll('[data-card-media][data-media-mode="carousel"]');
  cardMediaEls.forEach((container) => {
    const wrapper = container.closest('.collections__product-image-wrapper');
    if (!wrapper) return;
    if (container.getAttribute('data-no-cycle') === 'true') return;

    const frames = Array.from(container.querySelectorAll('.collections__product-image--frame, .collections__product-video'));
    if (frames.length <= 1) return;

    let idx = 0;
    let timer = null;

    const setActive = (nextIdx) => {
      idx = (nextIdx + frames.length) % frames.length;
      frames.forEach((el, i) => {
        el.classList.toggle('is-active', i === idx);
      });
    };

    const start = () => {
      // desktop only (hover)
      const canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      if (!canHover) return;
      if (timer) return;
      timer = window.setInterval(() => setActive(idx + 1), 900);
    };

    const stop = () => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      setActive(0);
    };

    wrapper.addEventListener('mouseenter', start);
    wrapper.addEventListener('mouseleave', stop);
  });

  // Testimonials slider
  const testimonialsContainer = document.querySelector('.testimonials__container');
  const testimonialSlides = document.querySelectorAll('.testimonials__slide');
  const testimonialDots = document.querySelectorAll('.testimonials__dot');
  const prevButton = document.querySelector('.testimonials__nav--prev');
  const nextButton = document.querySelector('.testimonials__nav--next');
  
  if (testimonialsContainer && testimonialSlides.length > 0) {
    let currentSlide = 0;
    
    function showSlide(index) {
      // Remove active class from all slides and dots
      testimonialSlides.forEach(slide => {
        slide.classList.remove('is-active');
      });
      
      testimonialDots.forEach(dot => {
        dot.classList.remove('testimonials__dot--active');
      });
      
      // Show current slide with animation
      if (testimonialSlides[index]) {
        // Use requestAnimationFrame for smooth transition
        requestAnimationFrame(() => {
          testimonialSlides[index].classList.add('is-active');
        });
      }
      
      // Activate current dot
      if (testimonialDots[index]) {
        testimonialDots[index].classList.add('testimonials__dot--active');
      }
      
      currentSlide = index;
    }
    
    // Initialize first slide
    if (testimonialSlides.length > 0) {
      showSlide(0);
    }
    
    // Next button
    if (nextButton) {
      nextButton.addEventListener('click', function() {
        const nextIndex = (currentSlide + 1) % testimonialSlides.length;
        showSlide(nextIndex);
      });
    }
    
    // Previous button
    if (prevButton) {
      prevButton.addEventListener('click', function() {
        const prevIndex = (currentSlide - 1 + testimonialSlides.length) % testimonialSlides.length;
        showSlide(prevIndex);
      });
    }
    
    // Dot navigation
    testimonialDots.forEach((dot, index) => {
      dot.addEventListener('click', function() {
        showSlide(index);
      });
    });

    // Swipe support for mobile
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 40; // Minimum distance in px to count as swipe

    testimonialsContainer.addEventListener('touchstart', (event) => {
      touchStartX = event.touches[0]?.clientX || 0;
    }, { passive: true });

    testimonialsContainer.addEventListener('touchmove', (event) => {
      touchEndX = event.touches[0]?.clientX || 0;
    }, { passive: true });

    testimonialsContainer.addEventListener('touchend', () => {
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) < swipeThreshold) return;
      if (distance < 0) {
        const nextIndex = (currentSlide + 1) % testimonialSlides.length;
        showSlide(nextIndex);
      } else {
        const prevIndex = (currentSlide - 1 + testimonialSlides.length) % testimonialSlides.length;
        showSlide(prevIndex);
      }
    });
  }

  // Community videos slider autoplay
  const communitySlider = document.querySelector('[data-community-slider]');
  if (communitySlider) {
    const slides = Array.from(communitySlider.querySelectorAll('[data-community-slide]'));
    const videos = slides.map(slide => slide.querySelector('[data-community-video]')).filter(Boolean);
    const track = communitySlider.querySelector('.product-community__track');
    const quote = document.querySelector('[data-community-quote]');
    const quoteThumb = quote?.querySelector('[data-community-quote-thumb]');
    const quoteAuthor = quote?.querySelector('[data-community-quote-author]');
    const quoteText = quote?.querySelector('[data-community-quote-text]');
    let activeIndex = 0;
    let fallbackTimer = null;
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 40;
    let userInteracted = false;

    // Preload all community videos immediately so they are ready to play
    videos.forEach((video) => {
      if (!video) return;
      const source = video.querySelector('source');
      if (source && !source.src && source.dataset.src) {
        source.src = source.dataset.src;
        video.load();
      }
    });

    function clearFallback() {
      if (fallbackTimer) {
        clearTimeout(fallbackTimer);
        fallbackTimer = null;
      }
    }

    function centerSlide(index) {
      const slide = slides[index];
      if (!slide || !track) return;
      const slideRect = slide.getBoundingClientRect();
      const trackRect = track.getBoundingClientRect();
      const currentScroll = track.scrollLeft;
      const offset = slideRect.left - trackRect.left - (trackRect.width - slideRect.width) / 2;
      track.scrollTo({ left: currentScroll + offset, behavior: 'smooth' });
    }

    function goToNext() {
      if (!slides.length) return;
      const nextIndex = (activeIndex + 1) % slides.length;
      playSlide(nextIndex);
    }

    function goToPrev() {
      if (!slides.length) return;
      const prevIndex = (activeIndex - 1 + slides.length) % slides.length;
      playSlide(prevIndex);
    }

    function playSlide(index) {
      if (!slides[index]) return;
      activeIndex = index;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === activeIndex);
      });
      videos.forEach((video, i) => {
        if (!video) return;
        if (i === activeIndex) {
          const source = video.querySelector('source');
          if (source && !source.src && source.dataset.src) {
            source.src = source.dataset.src;
            video.load();
          }
          slides[i]?.classList.add('is-loading');
          const markLoaded = () => {
            slides[i]?.classList.remove('is-loading');
          };
          const onLoaded = () => {
            markLoaded();
            video.currentTime = 0;
            const playPromise = video.play();
            if (playPromise && typeof playPromise.then === 'function') {
              playPromise.catch(() => {});
            }
          };
          if (video.readyState >= 2) {
            onLoaded();
          } else {
            video.addEventListener('loadeddata', onLoaded, { once: true });
            video.addEventListener('error', markLoaded, { once: true });
            video.addEventListener('stalled', markLoaded, { once: true });
          }
        } else {
          video.pause();
        }
      });
      const activeVideo = videos[activeIndex];
      if (activeVideo && quote) {
        const nextAuthor = activeVideo.getAttribute('data-author') || '';
        const nextText = activeVideo.getAttribute('data-text') || '';
        const nextThumb = activeVideo.getAttribute('data-thumb') || '';
        if (quoteAuthor) quoteAuthor.textContent = nextAuthor;
        if (quoteText) quoteText.textContent = nextText;
        if (quoteThumb && nextThumb) {
          quoteThumb.src = nextThumb;
          quoteThumb.alt = nextAuthor || 'Community review';
        }
      }
      centerSlide(activeIndex);
      clearFallback();
      fallbackTimer = setTimeout(goToNext, 12000);
    }

    videos.forEach((video, idx) => {
      if (!video) return;
      video.addEventListener('ended', () => {
        if (idx === activeIndex) {
          goToNext();
        }
      });
      video.addEventListener('play', () => {
        activeIndex = idx;
        slides.forEach((slide, i) => slide.classList.toggle('is-active', i === activeIndex));
        centerSlide(activeIndex);
        clearFallback();
      });
    });

    slides.forEach((slide, idx) => {
      slide.addEventListener('click', () => {
        userInteracted = true;
        playSlide(idx);
      });
    });

    if (track) {
      track.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0]?.clientX || 0;
      }, { passive: true });
      track.addEventListener('touchmove', (e) => {
        touchEndX = e.touches[0]?.clientX || 0;
      }, { passive: true });
      track.addEventListener('touchend', () => {
        const delta = touchEndX - touchStartX;
        if (Math.abs(delta) < swipeThreshold) return;
        userInteracted = true;
        if (delta < 0) {
          goToNext();
        } else {
          goToPrev();
        }
      });
    }

    playSlide(0);
  }

  // Debug premium video info in DOM
  const premiumVideoEl = document.querySelector('.product-premium__video-media');
  if (premiumVideoEl) {
    const sourceEl = premiumVideoEl.querySelector('source');
    console.log('[DEBUG premium video]', {
      dataset: premiumVideoEl.dataset,
      sourceSrc: sourceEl?.src || null,
      sourceDataSrc: sourceEl?.dataset?.src || null
    });
  }

  // Lazy load non-hero videos (e.g., premium block)
  const lazyVideos = Array.from(document.querySelectorAll('[data-lazy-video]'));
  if ('IntersectionObserver' in window && lazyVideos.length) {
    const setVideoLoading = (video, isLoading) => {
      const wrapper = video.closest('.product-premium__video');
      if (wrapper) {
        wrapper.classList.toggle('is-loading', !!isLoading);
      }
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const video = entry.target;
        const source = video.querySelector('source');
        if (source && !source.src && source.dataset.src) {
          source.src = source.dataset.src;
          setVideoLoading(video, true);
          const clearLoading = () => setVideoLoading(video, false);
          video.addEventListener('loadeddata', clearLoading, { once: true });
          video.addEventListener('error', clearLoading, { once: true });
          video.addEventListener('stalled', clearLoading, { once: true });
          video.load();
          if (video.autoplay) {
            const playPromise = video.play();
            if (playPromise?.catch) playPromise.catch(() => {});
          }
        }
        observer.unobserve(video);
      });
    }, { rootMargin: '100px 0px' });

    lazyVideos.forEach((video) => observer.observe(video));
  } else {
    lazyVideos.forEach((video) => {
      const source = video.querySelector('source');
      if (source && !source.src && source.dataset.src) {
        source.src = source.dataset.src;
        const setVideoLoading = (v, isLoading) => {
          const wrapper = v.closest('.product-premium__video');
          if (wrapper) {
            wrapper.classList.toggle('is-loading', !!isLoading);
          }
        };
        setVideoLoading(video, true);
        const clearLoading = () => setVideoLoading(video, false);
        video.addEventListener('loadeddata', clearLoading, { once: true });
        video.addEventListener('error', clearLoading, { once: true });
        video.addEventListener('stalled', clearLoading, { once: true });
        video.load();
        if (video.autoplay) {
          const playPromise = video.play();
          if (playPromise?.catch) playPromise.catch(() => {});
        }
      }
    });
  }
  
  // Update year in footer
  const yearElement = document.getElementById('year');
  if (yearElement) {
    yearElement.textContent = new Date().getFullYear();
  }
  
  // Language selector toggle
  const languageToggle = document.querySelector('.hero__language-toggle');
  const languageSelector = document.querySelector('.hero__language-selector');
  const rawLocalesAttr = document.body?.getAttribute('data-available-locales') || '';
  const rawLocalePrefixesAttr = document.body?.getAttribute('data-locale-prefixes') || '';

  function parseLocales(attrValue) {
    return attrValue
      .split(',')
      .map(item => item.trim())
      .filter(Boolean)
      .map(item => item.toLowerCase());
  }

  const localeCodes = parseLocales(rawLocalesAttr);
  const localePrefixes = parseLocales(rawLocalePrefixesAttr);

  const availableLocales = Array.from(new Set([...localeCodes, ...localePrefixes]));
  const normalizedLocales = Array.from(new Set(availableLocales.map(locale => locale.toLowerCase())));

  /**
   * Detects whether the first segment matches a known locale,
   * including combined prefixes like `en-pl` where every part maps to a locale.
   */
  function isLocalePrefix(segment) {
    if (!segment) return false;
    const lowerSegment = segment.toLowerCase();
    if (normalizedLocales.includes(lowerSegment)) {
      return true;
    }
    const parts = lowerSegment.split('-').filter(Boolean);
    return parts.length > 0 && parts.every(part => normalizedLocales.includes(part));
  }
  
  if (languageToggle && languageSelector) {
    languageToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = languageSelector.classList.contains('is-open');
      
      if (isOpen) {
        languageSelector.classList.remove('is-open');
        this.setAttribute('aria-expanded', 'false');
      } else {
        languageSelector.classList.add('is-open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
    
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!languageSelector.contains(e.target)) {
        languageSelector.classList.remove('is-open');
        languageToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
  
  // Removes the current locale prefix from a path
  function stripLocalePrefix(path) {
    if (!path.startsWith('/')) {
      path = `/${path}`;
    }
    const segments = path.split('/').filter(Boolean);
    const prefix = segments.length > 0 ? segments[0] : '';
    const hasLocalePrefix = segments.length > 0 && isLocalePrefix(prefix);
    if (hasLocalePrefix) {
      segments.shift();
    }
    const result = segments.length === 0 ? '/' : `/${segments.join('/')}`;
    return result;
  }

  // Global function for language change
  window.changeLanguage = function(event, locale, rootPath) {
    event.preventDefault();
    event.stopPropagation();
    
    let newUrl = '';
    const resolvedRootPath = (rootPath && rootPath.trim() !== '' ? rootPath : getRootUrlForLocale(locale)) || '';
    const currentPath = window.location.pathname;
    const cleanPath = stripLocalePrefix(currentPath);
    const queryString = window.location.search;
    const trimmedRoot = resolvedRootPath.trim();
    const hasRoot = trimmedRoot !== '' && trimmedRoot !== '/';

    function normalizeBase(pathValue) {
      if (!pathValue) return '';
      const trimmed = pathValue.trim();
      if (trimmed === '' || trimmed === '/') return '';
      if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
        try {
          const url = new URL(trimmed, window.location.origin);
          return `${url.origin}${url.pathname.replace(/\/$/, '')}`;
        } catch (e) {
          return trimmed.replace(/\/$/, '');
        }
      }
      return trimmed.replace(/\/$/, '');
    }
    
    const basePath = hasRoot ? normalizeBase(trimmedRoot) : '';
    
    if (basePath) {
      newUrl = cleanPath === '/' ? basePath : `${basePath}${cleanPath}`;
    } else {
      // Generate URL based on current pathname
      // Add new locale prefix if not English
      if (locale === 'en') {
        newUrl = cleanPath;
      } else {
        newUrl = cleanPath === '/' ? `/${locale}` : `/${locale}${cleanPath}`;
      }
    }
    
    // Add query string if present
    if (queryString) {
      newUrl += queryString;
    }
    
    // Reload page with new language
    window.location.href = newUrl;
  };
  
  // Collection filters functionality
  initCollectionFilters();
  
  // Product page functionality
  initProductPage();
  
  // Cart page functionality
  initCart();
});

// Collection filters initialization
function initCollectionFilters() {
  const filterButtons = document.querySelectorAll('.collections__filter-btn');
  const products = document.querySelectorAll('.collections__product');
  
  if (filterButtons.length === 0 || products.length === 0) {
    return; // Not on collection page
  }
  
  // Restore saved filter from localStorage
  const savedFilter = localStorage.getItem('collectionFilter');
  if (savedFilter) {
    const savedButton = document.querySelector(`.collections__filter-btn[data-filter="${savedFilter}"]`);
    if (savedButton) {
      // Remove active state from all buttons
      filterButtons.forEach(btn => btn.classList.remove('collections__filter-btn--active'));
      // Activate saved button
      savedButton.classList.add('collections__filter-btn--active');
      // Apply filter
      filterProducts(savedFilter, products);
      // Show active underline
      updateActiveUnderline(savedFilter);
    }
  } else {
    // Set initial active underline for 'all' filter
    updateActiveUnderline('all');
  }
  
  // Add click handlers to filter buttons
  filterButtons.forEach(button => {
    button.addEventListener('click', function() {
      const category = this.getAttribute('data-filter');
      
      // Update active button
      filterButtons.forEach(btn => btn.classList.remove('collections__filter-btn--active'));
      this.classList.add('collections__filter-btn--active');
      
      // Update active underline
      updateActiveUnderline(category);
      
      // Filter products
      filterProducts(category, products);
      
      // Save filter to localStorage
      localStorage.setItem('collectionFilter', category);
    });
  });
}

// Filter products by category
function filterProducts(category, products) {
  products.forEach(product => {
    const productTags = product.getAttribute('data-tags');
    if (category === 'all' || (productTags && productTags.includes(category))) {
      product.style.display = 'flex';
    } else {
      product.style.display = 'none';
    }
  });
}

// Update active underline image
function updateActiveUnderline(category) {
  const underlines = document.querySelectorAll('.collections__filter-underline-image');
  
  // Hide all underlines
  underlines.forEach(underline => {
    underline.classList.remove('active');
    // Ensure display: none is set after transition completes
    setTimeout(() => {
      if (!underline.classList.contains('active')) {
        underline.style.display = 'none';
      }
    }, 300);
  });
  
  // Show active underline
  const activeUnderline = document.querySelector(`.collections__filter-underline-image--${category}`);
  if (activeUnderline) {
    // Set display: block before adding active class for smooth transition
    activeUnderline.style.display = 'block';
    // Use requestAnimationFrame to ensure display is set before opacity transition
    requestAnimationFrame(() => {
      activeUnderline.classList.add('active');
    });
  }
}

// Product page initialization
function initProductPage() {
  const productForm = document.querySelector('[data-product-form]');
  
  if (!productForm) {
    return; // Not on product page
  }
  
  // Get product JSON data
  const productJsonElement = document.querySelector('[data-product-json]');
  if (!productJsonElement) {
    return;
  }
  
  let productData;
  try {
    productData = JSON.parse(productJsonElement.textContent);
  } catch (e) {
    console.error('Failed to parse product JSON:', e);
    return;
  }
  
  // Initialize gallery
  initProductGallery();
  const isBundleProduct = Boolean(productForm.getAttribute('data-bundle-id'));
  const addToCartButton = productForm.querySelector('.product-page__btn--add-to-cart');
  let bundleInitialized = false;
  if (isBundleProduct) {
    bundleInitialized = initBundleProductForm(productData, productForm);
  }
  
  if (!bundleInitialized) {
    initVariantSelection(productData, productForm);
    if (addToCartButton) {
      productForm.addEventListener('submit', () => {
        setButtonLoadingState(addToCartButton, true);
      });
    }
  }

  // Initialize buy-now buttons (both regular and sticky)
  initBuyNowButtons(productForm, isBundleProduct);

  // Initialize sticky CTA behavior
  initStickyCTA();

  // Load product recommendations
  loadProductRecommendations(productData.id);
}

// Product gallery functionality
function initProductGallery() {
  const thumbnails = document.querySelectorAll('.product-page__thumbnail');
  const mainImage = document.getElementById('mainProductImage');
  const slider = document.querySelector('[data-thumb-slider]');
  const track = slider ? slider.querySelector('[data-thumb-track]') : null;
  const prevBtn = slider ? slider.querySelector('[data-thumb-prev]') : null;
  const nextBtn = slider ? slider.querySelector('[data-thumb-next]') : null;
  
  if (!thumbnails.length || !mainImage) {
    return;
  }

  const getScrollStep = () => {
    const firstThumb = track?.querySelector('.product-page__thumbnail');
    if (firstThumb) {
      const rect = firstThumb.getBoundingClientRect();
      return rect.width + 12; // include gap
    }
    return track?.clientWidth || 200;
  };

  const updateNavState = () => {
    if (!track) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const atStart = track.scrollLeft <= 4;
    const atEnd = track.scrollLeft >= maxScroll - 4;
    if (prevBtn) {
      prevBtn.classList.toggle('is-disabled', atStart || maxScroll === 0);
      prevBtn.disabled = atStart || maxScroll === 0;
    }
    if (nextBtn) {
      nextBtn.classList.toggle('is-disabled', atEnd || maxScroll === 0);
      nextBtn.disabled = atEnd || maxScroll === 0;
    }
  };

  if (track) {
    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', () => {
      updateNavState();
    });

    // Touch swipe on thumbnails track
    let trackTouchStart = 0;
    let trackStartScroll = 0;
    let trackDragging = false;
    const onTrackTouchStart = (e) => {
      trackDragging = true;
      trackTouchStart = e.touches?.[0]?.clientX || 0;
      trackStartScroll = track.scrollLeft;
    };
    const onTrackTouchMove = (e) => {
      if (!trackDragging) return;
      const currentX = e.touches?.[0]?.clientX || trackTouchStart;
      const delta = currentX - trackTouchStart;
      track.scrollLeft = trackStartScroll - delta;
      updateNavState();
      if (Math.abs(delta) > 4) {
        e.preventDefault();
      }
    };
    const onTrackTouchEnd = () => {
      trackDragging = false;
    };
    track.addEventListener('touchstart', onTrackTouchStart, { passive: true });
    track.addEventListener('touchmove', onTrackTouchMove, { passive: false });
    track.addEventListener('touchend', onTrackTouchEnd);
    track.addEventListener('touchcancel', onTrackTouchEnd);
  }

  if (prevBtn && track) {
    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    });
  }
  if (nextBtn && track) {
    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    });
  }

  let swipeHintDismissed = false;
  const isMobile = window.matchMedia('(max-width: 899px)').matches;
  const canShowSwipeHint = () => {
    if (!isMobile || thumbnails.length <= 1) return false;
    try {
      return !localStorage.getItem('tmSwipeHintShown');
    } catch (e) {
      return true;
    }
  };

  function dismissSwipeHint() {
    if (swipeHintDismissed) return;
    swipeHintDismissed = true;
    const hint = document.querySelector('.product-page__swipe-hint');
    if (hint) {
      hint.classList.add('is-hidden');
      setTimeout(() => hint.remove(), 400);
    }
    try {
      localStorage.setItem('tmSwipeHintShown', '1');
    } catch (e) {
      /* ignore */
    }
  }

  function showSwipeHint() {
    if (!canShowSwipeHint()) return;
    const gallery = document.querySelector('.product-page__gallery');
    if (!gallery) return;
    const hint = document.createElement('div');
    hint.className = 'product-page__swipe-hint';
    hint.innerHTML = '<span class="product-page__swipe-arrow">←</span><span class="product-page__swipe-text">Swipe</span><span class="product-page__swipe-arrow">→</span>';
    gallery.appendChild(hint);
    setTimeout(dismissSwipeHint, 4000);
  }

  function goToIndex(nextIndex) {
    const target = thumbnails[nextIndex];
    if (target) {
      target.click();
    }
  }

  function getActiveIndex() {
    return Array.from(thumbnails).findIndex((thumb) =>
      thumb.classList.contains('product-page__thumbnail--active')
    );
  }

  let touchStartX = 0;
  let touchEndX = 0;
  let touchStartY = 0;
  let touchEndY = 0;
  const swipeThreshold = 40;
  const verticalIgnoreThreshold = 24;

  function handleTouchStart(e) {
    const x = e.touches?.[0]?.clientX || e.changedTouches?.[0]?.clientX || 0;
    const y = e.touches?.[0]?.clientY || e.changedTouches?.[0]?.clientY || 0;
    touchStartX = x;
    touchEndX = x;
    touchStartY = y;
    touchEndY = y;
  }

  function handleTouchMove(e) {
    touchEndX = e.touches?.[0]?.clientX || e.changedTouches?.[0]?.clientX || touchEndX || 0;
    touchEndY = e.touches?.[0]?.clientY || e.changedTouches?.[0]?.clientY || touchEndY || 0;
  }

  let swipedRecently = false;
  let lastSwipeTs = 0;
  let tapHandled = false;
  function handleTouchEnd() {
    const endX = touchEndX || touchStartX || (typeof touchStartX === 'number' ? touchStartX : 0);
    const endY = touchEndY || touchStartY || (typeof touchStartY === 'number' ? touchStartY : 0);
    const delta = endX - touchStartX;
    const deltaY = endY - touchStartY;
    const absDeltaX = Math.abs(delta);
    const absDeltaY = Math.abs(deltaY);
    const current = getActiveIndex();
    const rect = mainImage.getBoundingClientRect();
    const xRatio = rect.width > 0 ? (endX - rect.left) / rect.width : 0.5;

    // Ignore primarily vertical gestures (user likely scrolling)
    if (absDeltaY > absDeltaX && absDeltaY > verticalIgnoreThreshold) {
      return;
    }

    // Swipe navigation
    if (absDeltaX >= swipeThreshold) {
      if (current === -1) return;
      const dir = delta < 0 ? 1 : -1;
      const next = (current + dir + thumbnails.length) % thumbnails.length;
      goToIndex(next);
      swipedRecently = true;
      lastSwipeTs = Date.now();
      setTimeout(() => { swipedRecently = false; }, 300);
      dismissSwipeHint();
      return;
    }

    // Tap navigation / lightbox on touch devices
    tapHandled = true;
    if (xRatio <= 0.15) {
      const prevIndex = current === -1 ? thumbnails.length - 1 : (current - 1 + thumbnails.length) % thumbnails.length;
      goToIndex(prevIndex);
    } else if (xRatio >= 0.85) {
      const nextIndex = current === -1 ? 1 : (current + 1) % thumbnails.length;
      goToIndex(nextIndex);
    } else if (lightboxSources.length > 0) {
      const safeCurrent = current === -1 ? 0 : current;
      lightboxIndex = safeCurrent;
      renderLightbox(lightboxIndex);
    }
    setTimeout(() => { tapHandled = false; }, 250);
  }

  mainImage.addEventListener('touchstart', handleTouchStart, { passive: true });
  mainImage.addEventListener('touchmove', handleTouchMove, { passive: true });
  mainImage.addEventListener('touchend', handleTouchEnd);
  mainImage.addEventListener('touchcancel', () => {
    touchStartX = 0;
    touchEndX = 0;
  });

  // Lightbox logic
  const lightboxSources = Array.from(thumbnails).map((thumb) => {
    const img = thumb.querySelector('.product-page__thumbnail-image');
    return img?.getAttribute('data-full-src') || img?.src || '';
  }).filter(Boolean);

  let lightboxIndex = getActiveIndex();
  let lightboxRoot = null;

  function renderLightbox(index) {
    if (!lightboxRoot) {
      lightboxRoot = document.createElement('div');
      lightboxRoot.className = 'product-lightbox';
      lightboxRoot.innerHTML = `
        <div class="product-lightbox__backdrop" data-lightbox-close></div>
        <div class="product-lightbox__inner">
          <button class="product-lightbox__close" aria-label="Close" data-lightbox-close>×</button>
          <div class="product-lightbox__stage" data-lightbox-stage>
            <div class="product-lightbox__loader" aria-hidden="true"></div>
            <img class="product-lightbox__image" alt="" loading="lazy">
          </div>
        </div>
      `;
      document.body.appendChild(lightboxRoot);

      lightboxRoot.addEventListener('click', (e) => {
        if (e.target.dataset.lightboxClose !== undefined) {
          closeLightbox();
        }
      });

      const onKey = (e) => {
        if (!lightboxRoot || !lightboxRoot.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') changeLightbox(1);
        if (e.key === 'ArrowLeft') changeLightbox(-1);
      };
      document.addEventListener('keydown', onKey);

      const stageEl = lightboxRoot.querySelector('[data-lightbox-stage]');
      const imgEl = lightboxRoot.querySelector('.product-lightbox__image');
      const loaderEl = stageEl.querySelector('.product-lightbox__loader');

      // Click navigation: left half -> prev, right half -> next (desktop closes when clicking outside the image)
      stageEl.addEventListener('click', (event) => {
        const rect = stageEl.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const ratio = rect.width > 0 ? x / rect.width : 0.5;
        const isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        const imgRect = imgEl.getBoundingClientRect();

        if (isDesktop && imgRect.width > 0 && imgRect.height > 0) {
          let bounds = imgRect;
          const naturalWidth = imgEl.naturalWidth;
          const naturalHeight = imgEl.naturalHeight;

          if (naturalWidth > 0 && naturalHeight > 0) {
            const imgRatio = naturalWidth / naturalHeight;
            const rectRatio = imgRect.width / imgRect.height;
            let drawWidth = imgRect.width;
            let drawHeight = imgRect.height;
            let offsetX = 0;
            let offsetY = 0;

            if (rectRatio > imgRatio) {
              drawHeight = imgRect.height;
              drawWidth = drawHeight * imgRatio;
              offsetX = (imgRect.width - drawWidth) / 2;
            } else {
              drawWidth = imgRect.width;
              drawHeight = drawWidth / imgRatio;
              offsetY = (imgRect.height - drawHeight) / 2;
            }

            bounds = {
              left: imgRect.left + offsetX,
              right: imgRect.left + offsetX + drawWidth,
              top: imgRect.top + offsetY,
              bottom: imgRect.top + offsetY + drawHeight,
            };
          }

          const withinImage = (
            event.clientX >= bounds.left
            && event.clientX <= bounds.right
            && event.clientY >= bounds.top
            && event.clientY <= bounds.bottom
          );
          if (!withinImage) {
            closeLightbox();
            return;
          }
        }

        if (ratio <= 0.5) {
          changeLightbox(-1);
        } else {
          changeLightbox(1);
        }
      });

      // Swipe navigation inside lightbox
      let lbStartX = 0;
      let lbEndX = 0;
      let lbStartY = 0;
      let lbEndY = 0;
      const lbThreshold = 40;
      const lbVerticalThreshold = 60;
      const lbStartHandler = (ev) => {
        lbStartX = ev.touches[0]?.clientX || 0;
        lbEndX = lbStartX;
        lbStartY = ev.touches[0]?.clientY || 0;
        lbEndY = lbStartY;
      };
      const lbMoveHandler = (ev) => {
        lbEndX = ev.touches[0]?.clientX || 0;
        lbEndY = ev.touches[0]?.clientY || 0;
      };
      const lbEndHandler = () => {
        const deltaX = lbEndX - lbStartX;
        const deltaY = lbEndY - lbStartY;
        if (Math.abs(deltaY) >= lbVerticalThreshold && Math.abs(deltaY) > Math.abs(deltaX)) {
          closeLightbox();
        } else if (Math.abs(deltaX) >= lbThreshold) {
          changeLightbox(deltaX < 0 ? 1 : -1);
        }
        lbStartX = 0;
        lbEndX = 0;
        lbStartY = 0;
        lbEndY = 0;
      };
      imgEl.addEventListener('touchstart', lbStartHandler, { passive: true });
      imgEl.addEventListener('touchmove', lbMoveHandler, { passive: true });
      imgEl.addEventListener('touchend', lbEndHandler);
      imgEl.addEventListener('touchcancel', () => {
        lbStartX = 0;
        lbEndX = 0;
        lbStartY = 0;
        lbEndY = 0;
      });
    }

    const imgEl = lightboxRoot.querySelector('.product-lightbox__image');
    const stageEl = lightboxRoot.querySelector('[data-lightbox-stage]');
    const loaderEl = stageEl?.querySelector('.product-lightbox__loader');

    // Show loader while the image is loading
    if (stageEl && loaderEl) {
      stageEl.classList.add('is-loading');
    }
    imgEl.onload = () => {
      if (stageEl) stageEl.classList.remove('is-loading');
    };
    imgEl.onerror = () => {
      if (stageEl) stageEl.classList.remove('is-loading');
    };

    imgEl.src = lightboxSources[index];
    lightboxRoot.classList.add('is-open');
    document.body.classList.add('lightbox-open');
  }

  function closeLightbox() {
    if (lightboxRoot) {
      lightboxRoot.classList.remove('is-open');
    }
    document.body.classList.remove('lightbox-open');
  }

  function changeLightbox(direction) {
    if (!lightboxSources.length) return;
    lightboxIndex = (lightboxIndex + direction + lightboxSources.length) % lightboxSources.length;
    renderLightbox(lightboxIndex);
  }

  const scrollThumbIntoView = (thumb) => {
    if (!thumb || !track) return;
    const isMobile = window.matchMedia('(max-width: 899px)').matches;
    const trackRect = track.getBoundingClientRect();
    const thumbRect = thumb.getBoundingClientRect();
    if (isMobile) {
      const paddingRight = parseFloat(getComputedStyle(track).paddingRight || '0') || 0;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const maxUsableScroll = maxScroll; // allow full range; paddingRight is used only for snap calculation
      const thumbStart = thumb.offsetLeft;
      const thumbEnd = thumbStart + thumb.offsetWidth;
      const remainingAfterThumb = track.scrollWidth - thumbEnd;
      const snapToEndThreshold = paddingRight + 12; // small buffer

      // Default: center the active thumb
      let targetScroll = thumbStart - (track.clientWidth - thumb.offsetWidth) / 2;

      // If we're near the end, snap to the end instead of centering
      if (remainingAfterThumb <= snapToEndThreshold) {
        targetScroll = maxScroll;
      }

      // Clamp to bounds
      targetScroll = Math.max(0, Math.min(maxUsableScroll, targetScroll));
      track.scrollTo({ left: targetScroll, behavior: 'smooth' });
      return;
    }
    const overflowLeft = thumbRect.left - trackRect.left;
    const overflowRight = thumbRect.right - trackRect.right;
    if (overflowLeft < 0) {
      track.scrollBy({ left: overflowLeft - 8, behavior: 'smooth' });
    } else if (overflowRight > 0) {
      track.scrollBy({ left: overflowRight + 8, behavior: 'smooth' });
    }
  };

  if (lightboxSources.length > 0) {
    mainImage.style.cursor = 'zoom-in';
    mainImage.addEventListener('click', (e) => {
      if (tapHandled) {
        tapHandled = false;
        return;
      }
      if (swipedRecently && Date.now() - lastSwipeTs < 400) return;
      swipedRecently = false;

      const rect = mainImage.getBoundingClientRect();
      const xRatio = (e.clientX - rect.left) / rect.width;
      const current = getActiveIndex();
      const safeCurrent = current === -1 ? 0 : current;
      const ensureActive = () => {
        if (current === -1 && thumbnails.length) {
          thumbnails.forEach((t) => t.classList.remove('product-page__thumbnail--active'));
          thumbnails[0].classList.add('product-page__thumbnail--active');
          scrollThumbIntoView(thumbnails[0]);
        }
      };

      // Edge navigation: left 15% -> prev, right 15% -> next, center 70% -> lightbox
      if (xRatio <= 0.15) {
        ensureActive();
        const prevIndex = safeCurrent === 0 ? thumbnails.length - 1 : safeCurrent - 1;
        goToIndex(prevIndex);
        return;
      }
      if (xRatio >= 0.85) {
        ensureActive();
        const nextIndex = (safeCurrent + 1) % thumbnails.length;
        goToIndex(nextIndex);
        return;
      }

      // Center area -> open lightbox
      ensureActive();
      lightboxIndex = safeCurrent;
      renderLightbox(lightboxIndex);
    });
  }

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function() {
      const thumbnailImage = this.querySelector('.product-page__thumbnail-image');
      if (thumbnailImage && mainImage) {
        const fullSrc = thumbnailImage.getAttribute('data-full-src');
        if (fullSrc) {
          mainImage.src = fullSrc;
          mainImage.alt = thumbnailImage.alt;
        }
      }
      
      // Update active thumbnail
      thumbnails.forEach(t => t.classList.remove('product-page__thumbnail--active'));
      this.classList.add('product-page__thumbnail--active');
      scrollThumbIntoView(this);
      updateNavState();

      dismissSwipeHint();
    });
  });

  showSwipeHint();
  updateNavState();
}

// Variant selection functionality
function initVariantSelection(productData, productForm) {
  const colorSwatches = productForm.querySelectorAll('.product-page__color-swatch');
  const sizeButtons = productForm.querySelectorAll('.product-page__size-btn');
  const colorOption = productForm.querySelector('.product-page__color-option');
  const colorNameElement = colorOption ? colorOption.querySelector('.color-name') : null;
  const productSelect = productForm.querySelector('#productSelect');
  const priceElement = productForm.querySelector('#productPrice');
  const addToCartButton = productForm.querySelector('.product-page__btn--add-to-cart');
  const buyNowButtons = productForm.querySelectorAll('.product-page__btn--buy-now, .product-page__btn--buy-now-sticky');
  const wiggleAddEnabled = productForm.dataset.enableWiggleAddToCart === 'true';
  const wiggleBuyEnabled = productForm.dataset.enableWiggleBuyNow === 'true';
  const wiggleTrigger = (productForm.dataset.wiggleTrigger || 'both').toLowerCase();
  const wiggleOnColor = wiggleTrigger === 'color' || wiggleTrigger === 'both';
  const wiggleOnSize = wiggleTrigger === 'size' || wiggleTrigger === 'both';
  let wiggleTimer = null;

  const wiggleCtas = () => {
    const targets = [];
    if (wiggleAddEnabled && addToCartButton) targets.push(addToCartButton);
    if (wiggleBuyEnabled && buyNowButtons.length) {
      buyNowButtons.forEach((btn) => btn && targets.push(btn));
    }
    if (!targets.length) return;
    targets.forEach((btn) => {
      if (!btn) return;
      btn.classList.remove('cta-wiggle');
      // Force reflow so animation restarts each time
      void btn.offsetWidth;
      btn.classList.add('cta-wiggle');
    });
    if (wiggleTimer) clearTimeout(wiggleTimer);
    wiggleTimer = setTimeout(() => {
      targets.forEach((btn) => btn && btn.classList.remove('cta-wiggle'));
    }, 800);
  };

  const normalizeHandle = (val) =>
    (val || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-');

  // Detect option indexes for color/size (1-based)
  const optionHandles = Array.isArray(productData?.options)
    ? productData.options.map((opt) => normalizeHandle(opt))
    : [];
  const colorHandles = ['color', 'colour', 'kolor', 'kolir', 'cvet', 'tsvet'];
  const sizeHandles = ['size', 'razmer', 'rozmir', 'rozmer', 'rozmiar'];
  let colorIndex = optionHandles.findIndex((opt) => colorHandles.includes(opt)) + 1;
  let sizeIndex = optionHandles.findIndex((opt) => sizeHandles.includes(opt)) + 1;
  if (colorIndex === 0 && optionHandles.length >= 1) colorIndex = 1;
  if (sizeIndex === 0 && optionHandles.length >= 2) sizeIndex = 2;
  const getVariantOptionByIndex = (variant, idx) => (variant && idx ? variant[`option${idx}`] : null);

  // Clear any preset actives
  colorSwatches.forEach((swatch) => swatch.classList.remove('product-page__color-swatch--active'));
  sizeButtons.forEach((btn) => btn.classList.remove('product-page__size-btn--active'));

  let selectedColor = null;
  let selectedSize = null;

  const variants = Array.isArray(productData?.variants) ? productData.variants : [];

  function findVariant(colorValue, sizeValue) {
    const normColor = normalizeOption(colorValue);
    const normSize = normalizeOption(sizeValue);
    return variants.find((variant) => {
      const colorVal = normalizeOption(getVariantOptionByIndex(variant, colorIndex));
      const sizeVal = normalizeOption(getVariantOptionByIndex(variant, sizeIndex));
      const colorMatch = !normColor || colorVal === normColor;
      const sizeMatch = !normSize || sizeVal === normSize;
      return colorMatch && sizeMatch && variant.available;
    }) || null;
  }

  function setActiveSwatchByColor(colorValue) {
    if (!colorValue) return null;
    const normTarget = normalizeOption(colorValue);
    let target = null;
    colorSwatches.forEach((swatch) => {
      const name = swatch.getAttribute('data-color-name') || swatch.getAttribute('data-color-value');
      const isTarget = normalizeOption(name) === normTarget;
      swatch.classList.toggle('product-page__color-swatch--active', isTarget);
      if (isTarget) target = swatch;
    });
    if (target && colorNameElement) {
      const colorName = target.getAttribute('data-color-name') || target.getAttribute('data-color-value');
      colorNameElement.textContent = colorName || '';
    }
    if (target && colorOption) {
      const colorHex = target.getAttribute('data-color-hex');
      if (colorHex) {
        colorOption.style.backgroundColor = colorHex;
        updateColorOptionStyles(colorOption, colorHex);
      }
    }
    return target;
  }

  function setActiveSizeButton(sizeValue) {
    if (!sizeValue) return null;
    const normTarget = normalizeOption(sizeValue);
    let target = null;
    sizeButtons.forEach((btn) => {
      const btnSize =
        btn.getAttribute('data-size-value') ||
        btn.getAttribute('data-size-name') ||
        btn.getAttribute('data-size');
      const isTarget = normalizeOption(btnSize) === normTarget;
      btn.classList.toggle('product-page__size-btn--active', isTarget);
      if (isTarget) target = btn;
    });
    const activeSize = target
      ? target.getAttribute('data-size-value') || target.getAttribute('data-size-name') || target.getAttribute('data-size')
      : null;
    const sizeLabel = productForm.querySelector('#selectedSize');
    if (sizeLabel && activeSize) {
      sizeLabel.textContent = activeSize;
    }
    return target;
  }

  function updateSizeAvailability(colorValue) {
    sizeButtons.forEach((btn) => {
      const btnSize =
        btn.getAttribute('data-size-value') ||
        btn.getAttribute('data-size-name') ||
        btn.getAttribute('data-size');
      const variant = findVariant(colorValue, btnSize);
      const available = Boolean(variant);
      btn.disabled = false; // позволяем выбирать недоступные варианты
      btn.classList.toggle('is-disabled', !available);
      btn.setAttribute('data-variant-available', available ? 'true' : 'false');
    });
  }

  function updateColorAvailability(sizeValue) {
    colorSwatches.forEach((swatch) => {
      const swatchColor = swatch.getAttribute('data-color-name') || swatch.getAttribute('data-color-value');
      const variant = findVariant(swatchColor, sizeValue);
      const available = Boolean(variant);
      swatch.disabled = false; // позволяем выбирать недоступные варианты
      swatch.classList.toggle('is-disabled', !available);
      swatch.setAttribute('data-variant-available', available ? 'true' : 'false');
    });
  }

  // Color swatch selection
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.stopPropagation();
      if (this.disabled) return;
      
      setActiveSwatchByColor(this.getAttribute('data-color-name') || this.getAttribute('data-color-value'));
      selectedColor = this.getAttribute('data-color-value');
      
      updateSizeAvailability(selectedColor);
      updateColorAvailability(selectedSize);

      const matchingVariant = findVariant(selectedColor, selectedSize) || findVariant(selectedColor, null);
      if (matchingVariant) {
        const sizeVal = getVariantOptionByIndex(matchingVariant, sizeIndex);
        if (sizeVal) {
          setActiveSizeButton(sizeVal);
          selectedSize = sizeVal;
        }
      } else {
        sizeButtons.forEach((btn) => btn.classList.remove('product-page__size-btn--active'));
        selectedSize = null;
      }
      
      const matched = updateVariant(
        productData,
        selectedColor,
        selectedSize,
        productSelect,
        priceElement,
        addToCartButton
      );
      if (matched && wiggleOnColor) {
        wiggleCtas();
      }
    });
  });
  
  // Size button selection
  sizeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      if (this.disabled) {
        return;
      }
      
      const sizeSection = this.closest('.product-page__size-section');
      const buttonsInSection = sizeSection.querySelectorAll('.product-page__size-btn');
      
      // Update active button
      buttonsInSection.forEach(btn => btn.classList.remove('product-page__size-btn--active'));
      this.classList.add('product-page__size-btn--active');
      
      selectedSize =
        this.getAttribute('data-size-value') ||
        this.getAttribute('data-size-name') ||
        this.getAttribute('data-size');
      
      // Update size label
      const sizeLabel = sizeSection.querySelector('#selectedSize');
      if (sizeLabel) {
        sizeLabel.textContent = this.getAttribute('data-size-value') || selectedSize;
      }

      updateColorAvailability(selectedSize);

      const matched = updateVariant(
        productData,
        selectedColor,
        selectedSize,
        productSelect,
        priceElement,
        addToCartButton
      );
      if (!matched) {
        this.classList.remove('product-page__size-btn--active');
        selectedSize = null;
      } else {
        if (wiggleOnSize) {
          wiggleCtas();
        }
      }
    });
  });

  function setStateToVariant(variant) {
    if (!variant) return false;
    const variantColor = getVariantOptionByIndex(variant, colorIndex);
    const variantSize = getVariantOptionByIndex(variant, sizeIndex);
    if (productSelect) {
      productSelect.value = variant.id;
    }
    if (variantColor) {
      setActiveSwatchByColor(variantColor);
      selectedColor = variantColor;
    }
    if (variantSize) {
      setActiveSizeButton(variantSize);
      selectedSize = variantSize;
    }
    return true;
  }

  // Initial availability and sync with a real available variant
  const initialVariant =
    (productSelect?.value ? variants.find((v) => String(v.id) === String(productSelect.value) && v.available) : null) ||
    variants.find((v) => v.available) ||
    null;

  if (initialVariant) {
    setStateToVariant(initialVariant);
  } else {
    // No available variants: показываем sold out, но позволяем выбирать опции
    colorSwatches.forEach((swatch) => swatch.classList.remove('product-page__color-swatch--active'));
    sizeButtons.forEach((btn) => btn.classList.remove('product-page__size-btn--active'));
    selectedColor = null;
    selectedSize = null;
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.textContent =
        addToCartButton.getAttribute('data-sold-out-text') ||
        addToCartButton.textContent ||
        'SOLD OUT';
    }
  }

  updateSizeAvailability(selectedColor);
  updateColorAvailability(selectedSize);
  updateVariant(productData, selectedColor, selectedSize, productSelect, priceElement, addToCartButton);
}

// Update variant based on selected options
function updateVariant(productData, selectedColor, selectedSize, productSelect, priceElement, addToCartButton) {
  if (!productData || !productData.variants) {
    return null;
  }
  
  const normColor = normalizeOption(selectedColor);
  const normSize = normalizeOption(selectedSize);
  const variants = Array.isArray(productData.variants) ? productData.variants : [];

  const pickVariant = (colorVal, sizeVal, requireAvailable = true) => {
    const c = normalizeOption(colorVal);
    const s = normalizeOption(sizeVal);
    return variants.find((variant) => {
      if (requireAvailable && !variant.available) return false;
      const v1 = normalizeOption(variant.option1);
      const v2 = normalizeOption(variant.option2);
      const v3 = normalizeOption(variant.option3);
      const colorMatch = !c || v1 === c || v2 === c || v3 === c;
      const sizeMatch = !s || v1 === s || v2 === s || v3 === s;
      return colorMatch && sizeMatch;
    }) || null;
  };

  let matchingVariant = null;
  if (normColor && normSize) {
    matchingVariant =
      pickVariant(normColor, normSize, true) ||
      pickVariant(normColor, normSize, false);
  } else if (normColor) {
    matchingVariant =
      pickVariant(normColor, null, true) ||
      pickVariant(normColor, null, false);
  } else if (normSize) {
    matchingVariant =
      pickVariant(null, normSize, true) ||
      pickVariant(null, normSize, false);
  } else {
    matchingVariant = variants.find((v) => v.available) || null;
  }
  
  // Update UI with matching variant
 if (matchingVariant) {
    // Update hidden select
    if (productSelect) {
      productSelect.value = matchingVariant.id;
    }
    
    // Update price
    if (priceElement) {
      priceElement.textContent = formatMoney(matchingVariant.price);
    }
    
    // Update main image if variant has featured image
    if (matchingVariant.featured_image) {
      const mainImage = document.getElementById('mainProductImage');
      if (mainImage) {
        mainImage.src = matchingVariant.featured_image.src;
        mainImage.alt = matchingVariant.featured_image.alt || productData.title;
      }
    }
    // Update button availability
    if (addToCartButton) {
      if (matchingVariant.available) {
        addToCartButton.disabled = false;
        addToCartButton.textContent =
          addToCartButton.getAttribute('data-add-text') ||
          addToCartButton.textContent ||
          'ADD TO CART';
      } else {
        addToCartButton.disabled = true;
        addToCartButton.textContent =
          addToCartButton.getAttribute('data-sold-out-text') ||
          addToCartButton.textContent ||
          'SOLD OUT';
      }
    }

    // Update buy-now buttons (regular and sticky)
    const productForm = addToCartButton ? addToCartButton.closest('form') : document.querySelector('[data-product-form]');
    if (productForm) {
      const buyNowButtons = productForm.querySelectorAll('.product-page__btn--buy-now, .product-page__btn--buy-now-sticky');
      buyNowButtons.forEach((button) => {
        if (matchingVariant.available) {
          button.disabled = false;
          button.textContent =
            button.getAttribute('data-buy-now-text') ||
            button.textContent;
        } else {
          button.disabled = true;
          button.textContent =
            button.getAttribute('data-sold-out-text') ||
            button.textContent ||
            'SOLD OUT';
        }
      });
    }
  } else {
    // No available variant matches the selection
    if (productSelect) {
      productSelect.value = '';
    }
    if (addToCartButton) {
      addToCartButton.disabled = true;
      addToCartButton.textContent =
        addToCartButton.getAttribute('data-sold-out-text') ||
        addToCartButton.textContent ||
        'SOLD OUT';
    }

    // Update buy-now buttons when no variant matches
    const productForm = addToCartButton ? addToCartButton.closest('form') : document.querySelector('[data-product-form]');
    if (productForm) {
      const buyNowButtons = productForm.querySelectorAll('.product-page__btn--buy-now, .product-page__btn--buy-now-sticky');
      buyNowButtons.forEach((button) => {
        button.disabled = true;
        button.textContent =
          button.getAttribute('data-sold-out-text') ||
          button.textContent ||
          'SOLD OUT';
      });
    }
  }

  return matchingVariant;
}

// Format money using Shopify money format
function formatMoney(cents) {
  // Get money format from Shopify theme settings
  const moneyFormat = window.Shopify && window.Shopify.money_format 
    ? window.Shopify.money_format 
    : '{{amount_no_decimals}}';
  
  const amountNoDecimals = Math.round(cents / 100);
  
  // Replace placeholder with formatted amount (no decimals)
  return moneyFormat
    .replace('{{amount_no_decimals}}', amountNoDecimals)
    .replace('{{amount}}', amountNoDecimals)
    .replace('{{amount_with_comma_separator}}', String(amountNoDecimals).replace('.', ','));
}

// Check if color is dark (for text contrast)
function isColorDark(hexColor) {
  // Remove # if present
  const hex = hexColor.replace('#', '');
  
  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate relative luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Return true if color is dark (luminance < 0.5)
  return luminance < 0.5;
}

// Update color option styles based on background color
function updateColorOptionStyles(colorOption, colorHex) {
  if (!colorOption || !colorHex) return;
  
  const isDark = isColorDark(colorHex);
  
  // Update text colors based on background
  const colorLabel = colorOption.querySelector('.product-page__color-label');
  const sizeLabel = colorOption.querySelector('.product-page__size-label');
  const sizeGuideLink = colorOption.querySelector('.product-page__size-guide-link');
  const sizeButtons = colorOption.querySelectorAll('.product-page__size-btn');
  
  if (isDark) {
    if (colorLabel) colorLabel.style.color = 'white';
    if (sizeLabel) sizeLabel.style.color = 'white';
    if (sizeGuideLink) sizeGuideLink.style.color = 'rgba(255, 255, 255, 0.6)';
    sizeButtons.forEach(btn => {
      btn.style.borderColor = 'white';
      btn.style.color = 'white';
    });
  } else {
    if (colorLabel) colorLabel.style.color = '#486879';
    if (sizeLabel) sizeLabel.style.color = '#486879';
    if (sizeGuideLink) sizeGuideLink.style.color = '#8ca0ac';
    sizeButtons.forEach(btn => {
      btn.style.borderColor = '#486879';
      btn.style.color = '#486879';
    });
  }
}

// Bundle product initialization
function initBundleProductForm(productData, productForm) {
  const bundleSelector = document.querySelector('[data-bundle-selector]');
  const bundleId = productForm.getAttribute('data-bundle-id');

  if (!bundleSelector || !bundleId) {
    return false;
  }

  const bundleItems = [];
  window.__bundleItems = bundleItems; // Make bundleItems globally accessible for buy-now buttons
  const addToCartButton = productForm.querySelector('.product-page__btn--add-to-cart');
  const defaultAddText =
    addToCartButton &&
    (addToCartButton.getAttribute('data-add-text') || addToCartButton.textContent || 'ADD TO CART');
  const soldOutText =
    addToCartButton &&
    (addToCartButton.getAttribute('data-sold-out-text') || addToCartButton.textContent || 'SOLD OUT');

  function updateBundleAddToCartState() {
    const hasMissing = bundleItems.some((item) => !item.selectedVariantId);
    const hasUnavailable = bundleItems.some((item) => item.selectedVariantAvailable === false);

    // Update add-to-cart button
    if (addToCartButton) {
      if (hasMissing) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = defaultAddText || addToCartButton.textContent || 'ADD TO CART';
      } else if (hasUnavailable) {
        addToCartButton.disabled = true;
        addToCartButton.textContent = soldOutText || defaultAddText || addToCartButton.textContent || 'SOLD OUT';
      } else {
        addToCartButton.disabled = false;
        addToCartButton.textContent = defaultAddText || addToCartButton.textContent || 'ADD TO CART';
      }
    }

    // Update buy-now buttons (regular and sticky)
    const buyNowButtons = productForm.querySelectorAll('.product-page__btn--buy-now, .product-page__btn--buy-now-sticky');
    const buyNowDefaultText = buyNowButtons.length && buyNowButtons[0].getAttribute('data-buy-now-text');
    buyNowButtons.forEach((button) => {
      if (hasMissing) {
        button.disabled = true;
        button.textContent = buyNowDefaultText || button.textContent;
      } else if (hasUnavailable) {
        button.disabled = true;
        button.textContent = soldOutText || button.textContent || 'SOLD OUT';
      } else {
        button.disabled = false;
        button.textContent = buyNowDefaultText || button.textContent;
      }
    });
  }

  const itemElements = bundleSelector.querySelectorAll('[data-bundle-item-index]');

  itemElements.forEach((element, index) => {
    const previewImage = element.querySelector('.product-page__color-character-img');
    const titleNode = element.querySelector('.product-page__color-label');

    const productTitle =
      element.getAttribute('data-product-title') || (titleNode ? titleNode.textContent.trim() : '');
    const state = {
      index,
      element,
      productId: element.getAttribute('data-product-id'),
      handle: element.getAttribute('data-product-handle'),
      selectedVariantId: null,
      selectedColor: null,
      selectedSize: null,
      quantity: 1,
      productTitle,
      title: productTitle,
      imageUrl: element.getAttribute('data-product-image-url') || (previewImage ? previewImage.getAttribute('src') : ''),
      productData: null,
      selectedVariantAvailable: null,
    };

    const colorSwatches = element.querySelectorAll('.product-page__color-swatch');
    const activeSwatch = element.querySelector('.product-page__color-swatch--active');
    if (activeSwatch) {
      state.selectedVariantId = activeSwatch.getAttribute('data-variant-id');
      state.selectedColor = activeSwatch.getAttribute('data-color-name') || activeSwatch.getAttribute('data-color-value');
      
      // Initialize background color of product-page__color-option
      const colorOption = element.closest('.product-page__color-option');
      const colorHex = activeSwatch.getAttribute('data-color-hex');
      if (colorHex && colorOption) {
        // Only update if not already set (to preserve initial color from Liquid)
        if (!colorOption.style.backgroundColor) {
          colorOption.style.backgroundColor = colorHex;
        }
        updateColorOptionStyles(colorOption, colorHex);
      }
    }

    colorSwatches.forEach((swatch) => {
      swatch.addEventListener('click', (event) => {
        event.preventDefault();
        const swatchesInGroup = swatch
          .closest('.product-page__color-content')
          .querySelectorAll('.product-page__color-swatch');
        swatchesInGroup.forEach((btn) => btn.classList.remove('product-page__color-swatch--active'));
        swatch.classList.add('product-page__color-swatch--active');
        state.selectedVariantId = swatch.getAttribute('data-variant-id');
        state.selectedColor = swatch.getAttribute('data-color-name') || swatch.getAttribute('data-color-value');
        
        // Update background color of product-page__color-option
        const colorOption = element.closest('.product-page__color-option');
        const colorHex = swatch.getAttribute('data-color-hex');
        if (colorHex && colorOption) {
          colorOption.style.backgroundColor = colorHex;
          updateColorOptionStyles(colorOption, colorHex);
        }
        
        // Update color name in label
        const colorName = swatch.getAttribute('data-color-name');
        const colorNameElement = element.querySelector('.color-name');
        if (colorNameElement && colorName) {
          colorNameElement.textContent = colorName;
        }

        // Try to sync size with a matching variant for this color
        const matchedVariant =
          findAvailableVariant(state, state.selectedColor, state.selectedSize) ||
          findAvailableVariant(state, state.selectedColor, null);
        if (matchedVariant) {
          const variantSize = matchedVariant[`option${state.sizeIndex || 2}`];
          if (variantSize) {
            state.selectedSize = variantSize;
            const normSize = normalizeOption(variantSize);
            const sizeButtons = element.querySelectorAll('.product-page__size-btn');
            sizeButtons.forEach((button) => {
              const btnSize =
                button.getAttribute('data-size-value') ||
                button.getAttribute('data-size-name') ||
                button.getAttribute('data-size');
              const isActive = normalizeOption(btnSize) === normSize;
              button.classList.toggle('product-page__size-btn--active', isActive);
            });
            const sizeLabel = element.querySelector('.selected-size') || element.querySelector('#selectedSize');
            if (sizeLabel) sizeLabel.textContent = variantSize;
          }
          state.selectedVariantId = matchedVariant.id;
          state.selectedVariantAvailable = Boolean(matchedVariant.available);
        } else {
          state.selectedVariantId = null;
          state.selectedVariantAvailable = false;
        }

        updateVariantFromColorAndSize(element, state);
        updateBundleAvailability(state);
        updateBundleAddToCartState();
      });
    });

    const sizeButtons = element.querySelectorAll('.product-page__size-btn');
    const activeSize = element.querySelector('.product-page__size-btn--active');
    if (activeSize) {
      state.selectedSize =
        activeSize.getAttribute('data-size-value') ||
        activeSize.getAttribute('data-size-name') ||
        activeSize.getAttribute('data-size');
    }

    sizeButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        sizeButtons.forEach((button) => button.classList.remove('product-page__size-btn--active'));
        btn.classList.add('product-page__size-btn--active');
        state.selectedSize =
          btn.getAttribute('data-size-value') ||
          btn.getAttribute('data-size-name') ||
          btn.getAttribute('data-size');
        const sizeLabel = element.querySelector('.selected-size') || element.querySelector('#selectedSize');
        if (sizeLabel) {
          sizeLabel.textContent = btn.getAttribute('data-size-name') || state.selectedSize;
        }
        
        // Обновляем variantId на основе выбранного цвета и размера
        updateVariantFromColorAndSize(element, state);

        // Обновляем доступность опций
        updateBundleAvailability(state);
        updateBundleAddToCartState();
      });
    });
    
    // Функция для обновления variantId на основе цвета и размера
    function updateVariantFromColorAndSize(element, state) {
      const activeSwatch = element.querySelector('.product-page__color-swatch--active');
      const selectedColor = activeSwatch
        ? activeSwatch.getAttribute('data-color-name') || activeSwatch.getAttribute('data-color-value')
        : null;
      const selectedSize = state.selectedSize;

      // Находим вариант, который соответствует выбранному цвету и размеру
      const variant = findBundleVariant(state, selectedColor, selectedSize, { preferAvailable: true });
      state.selectedVariantId = variant ? variant.id : null;
      state.selectedVariantAvailable = Boolean(variant && variant.available);
    }

    bundleItems.push(state);

    // Подтягиваем данные продукта для проверки наличия и блокировки недоступных опций
    fetchBundleProductData(state.handle).then((productJson) => {
      state.productData = productJson;
      // Detect option indexes for color/size based on option names and available swatches/buttons
      const normalizeHandle = (val) =>
        (val || '')
          .toString()
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-');
      const optionHandles = Array.isArray(productJson?.options)
        ? productJson.options.map((opt) => normalizeHandle(opt))
        : [];
      const colorHandles = ['color', 'colour', 'kolor', 'kolir', 'cvet', 'tsvet'];
      const sizeHandles = ['size', 'razmer', 'rozmir', 'rozmer', 'rozmiar'];
      const swatchValues = new Set(
        Array.from(element.querySelectorAll('.product-page__color-swatch'))
          .map((sw) => sw.getAttribute('data-color-name') || sw.getAttribute('data-color-value'))
          .filter(Boolean)
          .map((v) => normalizeOption(v))
      );
      const sizeValues = new Set(
        Array.from(element.querySelectorAll('.product-page__size-btn'))
          .map((btn) => btn.getAttribute('data-size-value') || btn.getAttribute('data-size-name') || btn.getAttribute('data-size'))
          .filter(Boolean)
          .map((v) => normalizeOption(v))
      );
      const detectIndexByValues = (valuesSet) => {
        if (!valuesSet.size || !Array.isArray(productJson?.variants)) return 0;
        for (let idx = 1; idx <= 3; idx++) {
          const hasMatch = productJson.variants.some((v) => valuesSet.has(normalizeOption(v[`option${idx}`])));
          if (hasMatch) return idx;
        }
        return 0;
      };
      state.colorIndex = detectIndexByValues(swatchValues) || optionHandles.findIndex((opt) => colorHandles.includes(opt)) + 1 || 1;
      state.sizeIndex = detectIndexByValues(sizeValues) || optionHandles.findIndex((opt) => sizeHandles.includes(opt)) + 1 || 2;

      // Set first available variant as active
      const firstAvailable = Array.isArray(productJson.variants)
        ? productJson.variants.find((v) => v.available)
        : null;
      if (firstAvailable) {
        const colorVal = firstAvailable[`option${state.colorIndex}`];
        const sizeVal = firstAvailable[`option${state.sizeIndex}`];
        state.selectedVariantId = firstAvailable.id;
        state.selectedColor = colorVal;
        state.selectedSize = sizeVal;

        // Activate swatch
        if (colorVal) {
          const normColor = normalizeOption(colorVal);
          element.querySelectorAll('.product-page__color-swatch').forEach((sw) => {
            const swName = sw.getAttribute('data-color-name') || sw.getAttribute('data-color-value');
            const isActive = normalizeOption(swName) === normColor;
            sw.classList.toggle('product-page__color-swatch--active', isActive);
            if (isActive) {
              const colorHex = sw.getAttribute('data-color-hex');
              const colorOption = element.closest('.product-page__color-option');
              if (colorHex && colorOption) {
                colorOption.style.backgroundColor = colorHex;
                updateColorOptionStyles(colorOption, colorHex);
              }
              const colorLabel = element.querySelector('.color-name');
              if (colorLabel) colorLabel.textContent = swName || '';
            }
          });
        }

        // Activate size
        if (sizeVal) {
          const normSize = normalizeOption(sizeVal);
          element.querySelectorAll('.product-page__size-btn').forEach((btn) => {
            const btnSize =
              btn.getAttribute('data-size-value') ||
              btn.getAttribute('data-size-name') ||
              btn.getAttribute('data-size');
            const isActive = normalizeOption(btnSize) === normSize;
            btn.classList.toggle('product-page__size-btn--active', isActive);
          });
          const sizeLabel = element.querySelector('.selected-size');
          if (sizeLabel) sizeLabel.textContent = sizeVal;
        }
      }

      updateBundleAvailability(state);
      updateBundleAddToCartState();
    });
  });

  updateBundleAddToCartState();

  if (!addToCartButton) {
    return true;
  }

  // For bundle products, intercept form submission instead of button click
  productForm.addEventListener('submit', (event) => {
    // Check if the submit was triggered by add-to-cart button (not buy-now button)
    // Buy-now buttons are type="button" so they won't trigger submit
    // Only add-to-cart button with type="submit" will trigger this
    event.preventDefault();
    handleBundleCartSubmission(bundleId, bundleItems, addToCartButton);
  });

  return true;
}

// Initialize buy-now buttons for checkout redirect
function initBuyNowButtons(productForm, isBundleProduct) {
  const buyNowButtons = productForm.querySelectorAll('.product-page__btn--buy-now, .product-page__btn--buy-now-sticky');

  if (!buyNowButtons.length) {
    return;
  }

  buyNowButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (isBundleProduct) {
        const bundleId = productForm.getAttribute('data-bundle-id');
        const bundleItems = window.__bundleItems || [];
        handleBundleBuyNowSubmission(bundleId, bundleItems, button);
      } else {
        handleBuyNowSubmission(productForm, button);
      }
    });
  });
}

// Handle buy-now for regular (non-bundle) products
async function handleBuyNowSubmission(productForm, button) {
  const formData = new FormData(productForm);
  const variantId = formData.get('id');
  const quantity = formData.get('quantity') || 1;

  if (!variantId) {
    const message = (document.body && document.body.dataset.alertSelectOptions) || 'Please select a product option.';
    alert(message);
    return;
  }

  setButtonLoadingState(button, true);

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to add item to cart');
    }

    // Redirect to checkout
    window.location.href = '/checkout';
  } catch (error) {
    console.error('Buy now submission error:', error);
    const errorMessage = getAlertText('alertGeneric', 'Упс! Что-то пошло не так…');
    alert(errorMessage);
    setButtonLoadingState(button, false);
  }
}

// Initialize sticky CTA behavior - show sticky button only when original scrolls out of view
function initStickyCTA() {
  const primaryButton = document.querySelector('.product-page__actions .product-page__btn--primary');
  const stickyContainer = document.querySelector('.product-page__sticky-cta');
  const saleBanner = document.querySelector('.sale-banner');
  const isDesktop = window.matchMedia('(min-width: 1024px)').matches;

  if (!primaryButton || !stickyContainer) {
    return;
  }

  if (isDesktop) {
    // Ensure sticky CTA stays hidden on desktop
    stickyContainer.style.display = 'none';
    return;
  }

  // Get header element to account for fixed header height
  const header = document.querySelector('header');
  const getHeaderHeight = () => header ? header.offsetHeight : 0;

  // Add transitions for smooth animations
  primaryButton.style.transition = 'opacity 0.3s ease';
  if (saleBanner) {
    saleBanner.style.transition = 'bottom 0.3s ease';
  }

  let isSticky = false;

  function checkStickyState() {
    const rect = primaryButton.getBoundingClientRect();
    const headerHeight = getHeaderHeight();

    // Check if user scrolled DOWN past the button
    // Button's top edge has crossed above the header (button is going out of view at top)
    const shouldBeSticky = window.innerHeight - rect.bottom > 0;

    if (shouldBeSticky && !isSticky) {
      // Show sticky version
      isSticky = true;

      // Hide original button with fade out
      primaryButton.style.opacity = '0';
      primaryButton.style.pointerEvents = 'none';

      // Show sticky button with animation
      stickyContainer.style.display = 'block';
      // Force reflow to enable CSS transition
      requestAnimationFrame(() => {
        stickyContainer.classList.add('is-visible');
      });

      // Move sale banner up to avoid blocking sticky CTA
      if (saleBanner) {
        // Get sticky container height (approximately 80px with padding)
        const stickyHeight = 80;
        saleBanner.style.bottom = `${18 + stickyHeight}px`;
      }
    } else if (!shouldBeSticky && isSticky) {
      // Hide sticky, show original
      isSticky = false;

      // Show original button
      primaryButton.style.opacity = '1';
      primaryButton.style.pointerEvents = 'auto';

      // Hide sticky button with animation
      stickyContainer.classList.remove('is-visible');
      // Wait for animation to finish before hiding
      setTimeout(() => {
        if (!isSticky) {
          stickyContainer.style.display = 'none';
        }
      }, 300); // Match CSS transition duration

      // Restore sale banner to original position
      if (saleBanner) {
        saleBanner.style.bottom = '18px';
      }
    }
  }

  // Check on scroll with throttling using requestAnimationFrame
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkStickyState();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Check on page load
  checkStickyState();
}

// Handle buy-now for bundle products (similar to handleBundleCartSubmission but redirects to checkout)
async function handleBundleBuyNowSubmission(bundleId, bundleItems, button) {
  const hasMissingVariant = bundleItems.some((item) => !item.selectedVariantId);
  if (hasMissingVariant) {
    const message = (document.body && document.body.dataset.alertSelectOptions) || 'Please select options for each product in the bundle.';
    alert(message);
    return;
  }
  const hasUnavailableVariant = bundleItems.some((item) => item.selectedVariantAvailable === false);
  if (hasUnavailableVariant) {
    const soldOutMessage =
      (button && button.getAttribute('data-sold-out-text')) ||
      (document.body && document.body.dataset.alertSoldOut) ||
      'One of the selected items is sold out.';
    alert(soldOutMessage);
    return;
  }

  setButtonLoadingState(button, true);

  const componentMarker = `${bundleId}-${Date.now()}`;
  const componentItemsPayload = buildComponentCartItems(bundleItems, bundleId, componentMarker);
  let componentsAdded = false;

  try {
    if (componentItemsPayload.length) {
      await addLineItemsToCart(componentItemsPayload, 'Failed to add bundle items to cart.');
      componentsAdded = true;
    }

    const compareAtCents = await calculateBundleCompareAt(bundleItems);

    const quotePayload = {
      quantity: 1,
      items: bundleItems.map((item) => ({
        variantId: String(item.selectedVariantId),
        quantity: item.quantity || 1,
      })),
    };

    const quoteResponse = await fetch(buildBundleApiUrl(`/api/theme/bundles/${bundleId}/quote`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(quotePayload),
    });
    if (!quoteResponse.ok) {
      let errorMessage = 'Failed to calculate bundle quote';
      try {
        const errorData = await quoteResponse.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // Ignore JSON parse errors, use default message
      }
      throw new Error(errorMessage);
    }

    const quote = await quoteResponse.json();
    const discountedCents = normalizeQuotePriceCents(quote);
    if (discountedCents === null) {
      throw new Error('Invalid quote: missing discounted price');
    }

    const cartState = await fetchCartState();
    const cartItems = Array.isArray(cartState?.items) ? cartState.items : [];
    const scopedCartItems =
      componentsAdded && componentMarker
        ? cartItems.filter(
            (item) =>
              item?.properties && item.properties._bundle_component_marker === componentMarker
          )
        : cartItems;

    if (componentsAdded && componentMarker && scopedCartItems.length === 0) {
      throw new Error('Unable to track bundle items in cart. Please try again.');
    }

    const transformQuotePayload = {
      quantity: quote.quantity,
      currency: quote.currency,
      basePrice: quote.subtotal?.amount || quote.total?.amount || 0,
      items: quotePayload.items.map((item) => ({
        variantId: String(item.variantId),
        quantity: item.quantity,
      })),
    };

    const transformPayload = {
      bundleId,
      quote: transformQuotePayload,
      cart: {
        lines: buildCartLinesFromState(scopedCartItems),
      },
    };

    const transformResponse = await fetch(buildBundleApiUrl('/api/theme/cart/transform'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(transformPayload),
    });

    if (!transformResponse.ok) {
      let errorMessage = 'Failed to transform cart';
      try {
        const errorData = await transformResponse.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // Ignore JSON parse errors, use default message
      }
      throw new Error(errorMessage);
    }
    const transformation = await transformResponse.json();

    if (!transformation.addBundleLine) {
      throw new Error('Transformation missing bundle line');
    }

    const removeLineIDs =
      Array.isArray(transformation.removeLineIDs) && transformation.removeLineIDs.length
        ? transformation.removeLineIDs
        : extractLineKeysByMarker(cartItems, componentMarker);

    if (removeLineIDs.length) {
      await removeCartLinesById(removeLineIDs);
    }

    await addBundleLineToCart(transformation.addBundleLine, bundleId, bundleItems, compareAtCents);

    // Redirect to checkout instead of cart
    window.location.href = '/checkout';
  } catch (error) {
    console.error('Bundle buy now submission error:', error);
    if (componentsAdded) {
      await cleanupBundleComponents(componentMarker);
    }
    const errorMessage = getAlertText('alertGeneric', 'Упс! Что-то пошло не так…');
    alert(errorMessage);
  } finally {
    setButtonLoadingState(button, false);
  }
}

async function handleBundleCartSubmission(bundleId, bundleItems, button) {
  const hasMissingVariant = bundleItems.some((item) => !item.selectedVariantId);
  if (hasMissingVariant) {
    const message = (document.body && document.body.dataset.alertSelectOptions) || 'Please select options for each product in the bundle.';
    alert(message);
    return;
  }
  const hasUnavailableVariant = bundleItems.some((item) => item.selectedVariantAvailable === false);
  if (hasUnavailableVariant) {
    const soldOutMessage =
      (button && button.getAttribute('data-sold-out-text')) ||
      (document.body && document.body.dataset.alertSoldOut) ||
      'One of the selected items is sold out.';
    alert(soldOutMessage);
    return;
  }

  setButtonLoadingState(button, true);

  const componentMarker = `${bundleId}-${Date.now()}`;
  const componentItemsPayload = buildComponentCartItems(bundleItems, bundleId, componentMarker);
  let componentsAdded = false;

  try {
    if (componentItemsPayload.length) {
      await addLineItemsToCart(componentItemsPayload, 'Failed to add bundle items to cart.');
      componentsAdded = true;
    }

    const compareAtCents = await calculateBundleCompareAt(bundleItems);

    const quotePayload = {
      quantity: 1,
      items: bundleItems.map((item) => ({
        variantId: String(item.selectedVariantId),
        quantity: item.quantity || 1,
      })),
    };

    const quoteResponse = await fetch(buildBundleApiUrl(`/api/theme/bundles/${bundleId}/quote`), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(quotePayload),
    });
    if (!quoteResponse.ok) {
      let errorMessage = 'Failed to calculate bundle quote';
      try {
        const errorData = await quoteResponse.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // Ignore JSON parse errors, use default message
      }
      throw new Error(errorMessage);
    }
    const quote = await quoteResponse.json();

    const cart = await fetchCartState();
    const cartItems = Array.isArray(cart?.items) ? cart.items : [];
    const scopedCartItems =
      componentsAdded && componentMarker
        ? cartItems.filter(
            (item) =>
              item?.properties && item.properties._bundle_component_marker === componentMarker
          )
        : cartItems;

    if (componentsAdded && componentMarker && scopedCartItems.length === 0) {
      throw new Error('Unable to track bundle items in cart. Please try again.');
    }

    const transformQuotePayload = {
      quantity: quote.quantity,
      currency: quote.currency,
      basePrice: quote.subtotal?.amount || quote.total?.amount || 0,
      items: quotePayload.items.map((item) => ({
        variantId: String(item.variantId),
        quantity: item.quantity,
      })),
    };

    const transformPayload = {
      bundleId,
      quote: transformQuotePayload,
      cart: {
        lines: buildCartLinesFromState(scopedCartItems),
      },
    };

    const transformResponse = await fetch(buildBundleApiUrl('/api/theme/cart/transform'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(transformPayload),
    });
    if (!transformResponse.ok) {
      let errorMessage = 'Failed to transform cart';
      try {
        const errorData = await transformResponse.json();
        if (errorData.error) {
          errorMessage = errorData.error;
        } else if (errorData.message) {
          errorMessage = errorData.message;
        }
      } catch (e) {
        // Ignore JSON parse errors, use default message
      }
      throw new Error(errorMessage);
    }
    const transformation = await transformResponse.json();

    if (!transformation.addBundleLine) {
      throw new Error('Transformation missing bundle line');
    }

    const removeLineIDs =
      Array.isArray(transformation.removeLineIDs) && transformation.removeLineIDs.length
        ? transformation.removeLineIDs
        : extractLineKeysByMarker(cartItems, componentMarker);

    if (removeLineIDs.length) {
      await removeCartLinesById(removeLineIDs);
    }

    await addBundleLineToCart(transformation.addBundleLine, bundleId, bundleItems, compareAtCents);

    window.location.href = '/cart';
  } catch (error) {
    console.error('Bundle cart submission error:', error);
    if (componentsAdded) {
      await cleanupBundleComponents(componentMarker);
    }
    const errorMessage = getAlertText('alertGeneric', 'Упс! Что-то пошло не так…');
    alert(errorMessage);
  } finally {
    setButtonLoadingState(button, false);
  }
}

function buildComponentCartItems(bundleItems, bundleId, marker) {
  if (!Array.isArray(bundleItems)) {
    return [];
  }
  return bundleItems
    .map((item, index) => {
      const numericId = Number(item.selectedVariantId);
      if (!numericId || Number.isNaN(numericId)) {
        return null;
      }
      return {
        id: numericId,
        quantity: item.quantity || 1,
        properties: {
          _bundle_id: bundleId,
          _bundle_component_marker: marker,
          _bundle_component_position: index + 1,
        },
      };
    })
    .filter(Boolean);
}

function normalizeQuotePriceCents(quote) {
  if (!quote || typeof quote !== 'object') {
    return null;
  }

  const rawDiscounted = quote.discountedPriceCents;
  if (rawDiscounted === 0 || rawDiscounted) {
    const numeric = typeof rawDiscounted === 'number' ? rawDiscounted : parseFloat(rawDiscounted);
    if (!Number.isNaN(numeric)) {
      return Math.round(numeric);
    }
  }

  const fallbackAmount =
    quote.total?.amount ??
    quote.subtotal?.amount ??
    quote.price?.amount ??
    quote.total ??
    quote.subtotal;

  if (fallbackAmount === 0 || fallbackAmount) {
    const numeric =
      typeof fallbackAmount === 'number' ? fallbackAmount : parseFloat(fallbackAmount);
    if (!Number.isNaN(numeric)) {
      return numeric >= 1000 ? Math.round(numeric) : Math.round(numeric * 100);
    }
  }

  return null;
}

async function addLineItemsToCart(items, errorMessage = 'Failed to add items to cart.') {
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  });
  if (!response.ok) {
    throw new Error(errorMessage);
  }
  return response.json();
}

async function fetchCartState() {
  const cartResponse = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
  if (!cartResponse.ok) {
    throw new Error('Failed to load cart');
  }
  return cartResponse.json();
}

function extractLineKeysByMarker(cartItems, marker) {
  if (!marker || !Array.isArray(cartItems)) {
    return [];
  }
  return cartItems
    .filter(
      (item) => item?.properties && item.properties._bundle_component_marker === marker && item.key
    )
    .map((item) => item.key);
}

async function removeCartLinesById(lineIds) {
  for (const lineId of lineIds) {
    if (!lineId) {
      continue;
    }
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineId, quantity: 0 }),
    });
    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      throw new Error(errorBody.message || 'Failed to update cart');
    }
  }
}

async function cleanupBundleComponents(marker) {
  if (!marker) {
    return;
  }
  try {
    const cart = await fetchCartState();
    const keys = extractLineKeysByMarker(cart?.items || [], marker);
    if (keys.length) {
      await removeCartLinesById(keys);
    }
  } catch (cleanupError) {
    console.warn('Failed to cleanup bundle components', cleanupError);
  }
}

async function addBundleLineToCart(bundleLine, bundleId, bundleItems, compareAtCents) {
  const variantId = extractNumericIdFromGid(bundleLine.variantId);
  if (!variantId) {
    throw new Error('Bundle variant is missing');
  }
  const normalizedItems = Array.isArray(bundleItems) ? bundleItems : [];
  const readableBundleItems = normalizedItems
    .map((item, idx) => {
      const title = item.productTitle || item.title || 'Item';
      const color = item.selectedColor || item.color;
      const size = item.selectedSize || item.size;
      const qty = item.quantity || 1;
      const variantParts = [];
      if (color) variantParts.push(color);
      if (size) variantParts.push(size);
      const variantText = variantParts.length ? ` - ${variantParts.join(' / ')}` : '';
      const qtyText = qty > 1 ? ` x${qty}` : '';
      return `${idx + 1}. ${title}${variantText}${qtyText}`;
    })
    .filter(Boolean);

  const bundleProperties = {
    _bundle_id: bundleId,
    ...(compareAtCents ? { _bundle_compare_at_cents: compareAtCents } : {}),
    _bundle_items: JSON.stringify(
      normalizedItems.map((item) => ({
        productId: item.productId,
        handle: item.handle,
        title: item.title,
        productTitle: item.productTitle,
        imageUrl: item.imageUrl,
        variantId: String(item.selectedVariantId),
        color: item.selectedColor,
        size: item.selectedSize,
      }))
    ),
  };

  readableBundleItems.forEach((line, idx) => {
    bundleProperties[`Bundle item ${idx + 1}`] = line;
  });

  await addLineItemsToCart(
    [
      {
        id: Number(variantId),
        quantity: bundleLine.quantity || 1,
        properties: bundleProperties,
      },
    ],
    'Failed to add bundle to cart'
  );
}

function buildCartLinesFromState(cartItems) {
  if (!Array.isArray(cartItems)) {
    return [];
  }
  return cartItems.map((item) => ({
    id: item.key,
    productId: item.product_id ? `gid://shopify/Product/${item.product_id}` : '',
    variantId: `gid://shopify/ProductVariant/${item.variant_id}`,
    quantity: item.quantity,
  }));
}

function extractNumericIdFromGid(gid) {
  if (!gid || typeof gid !== 'string') {
    return null;
  }
  const parts = gid.split('/');
  return parts[parts.length - 1] || gid;
}

// Fetch product json for bundle items (cached)
async function fetchBundleProductData(handle) {
  if (!handle) return null;
  if (bundleProductCache.has(handle)) {
    return bundleProductCache.get(handle);
  }
  try {
    const resp = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!resp.ok) {
      bundleProductCache.set(handle, null);
      return null;
    }
    const data = await resp.json();
    bundleProductCache.set(handle, data);
    return data;
  } catch (e) {
    bundleProductCache.set(handle, null);
    return null;
  }
}

function normalizeOption(value) {
  if (!value) return '';
  return String(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');
}

function findBundleVariant(state, color, size, { preferAvailable = true, requireAvailable = false } = {}) {
  if (!state || !state.productData || !Array.isArray(state.productData.variants)) {
    return null;
  }
  const normColor = normalizeOption(color);
  const normSize = normalizeOption(size);
  const variants = state.productData.variants;
  const colorIdx = state.colorIndex || 1;
  const sizeIdx = state.sizeIndex || 2;
  const matches = variants.filter((variant) => {
    const vColor = normalizeOption(variant[`option${colorIdx}`]);
    const vSize = normalizeOption(variant[`option${sizeIdx}`]);
    const v3 = normalizeOption(variant.option3);
    const colorMatch = !normColor || vColor === normColor || vSize === normColor || v3 === normColor;
    const sizeMatch = !normSize || vColor === normSize || vSize === normSize || v3 === normSize;
    return colorMatch && sizeMatch;
  });

  if (!matches.length) {
    return null;
  }

  if (requireAvailable) {
    return matches.find((variant) => variant.available) || null;
  }

  if (preferAvailable) {
    const availableMatch = matches.find((variant) => variant.available);
    if (availableMatch) {
      return availableMatch;
    }
  }

  return matches[0] || null;
}

function findAvailableVariant(state, color, size) {
  return findBundleVariant(state, color, size, { preferAvailable: true, requireAvailable: true });
}

function updateBundleAvailability(state) {
  if (!state || !state.element || !state.productData || !Array.isArray(state.productData.variants)) {
    return;
  }

  // Disable/enable size buttons based on selected color
  const sizeButtons = state.element.querySelectorAll('.product-page__size-btn');
  sizeButtons.forEach((btn) => {
    const btnSize =
      btn.getAttribute('data-size-value') ||
      btn.getAttribute('data-size-name') ||
      btn.getAttribute('data-size');
    const variant = findBundleVariant(state, state.selectedColor, btnSize, { preferAvailable: true });
    const isAvailable = Boolean(variant && variant.available);
    btn.disabled = false;
    btn.classList.toggle('is-disabled', !isAvailable);
    btn.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
  });

  // Disable/enable color swatches based on selected size
  const swatches = state.element.querySelectorAll('.product-page__color-swatch');
  swatches.forEach((swatch) => {
    const swatchColor = swatch.getAttribute('data-color-name') || swatch.getAttribute('data-color-value');
    const variant = findBundleVariant(state, swatchColor, state.selectedSize, { preferAvailable: true });
    const isAvailable = Boolean(variant && variant.available);
    swatch.disabled = false;
    swatch.classList.toggle('is-disabled', !isAvailable);
    swatch.setAttribute('data-variant-available', isAvailable ? 'true' : 'false');
  });

  const resolvedVariant =
    findBundleVariant(state, state.selectedColor, state.selectedSize, { preferAvailable: true }) ||
    findBundleVariant(state, state.selectedColor, state.selectedSize, { preferAvailable: false });

  state.selectedVariantId = resolvedVariant ? resolvedVariant.id : null;
  state.selectedVariantAvailable = resolvedVariant ? Boolean(resolvedVariant.available) : false;
}

// Calculate total full price of bundle items to show savings in cart
async function calculateBundleCompareAt(bundleItems) {
  try {
    const cache = new Map();
    let total = 0;

    for (const item of bundleItems) {
      const handle = item.handle;
      const variantId = item.selectedVariantId;
      if (!handle || !variantId) {
        continue;
      }

      if (!cache.has(handle)) {
        const resp = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
        if (!resp.ok) {
          cache.set(handle, null);
        } else {
          cache.set(handle, await resp.json());
        }
      }
      const productData = cache.get(handle);
      if (!productData || !productData.variants) continue;

      const numericVariantId = parseInt(String(variantId).replace(/\D/g, ''), 10);
      const variant = productData.variants.find((v) => v.id === numericVariantId);
      if (!variant) continue;

      const rawCompareAt = typeof variant.compare_at_price !== 'undefined' && variant.compare_at_price !== null
        ? variant.compare_at_price
        : variant.price;
      const numericPrice = typeof rawCompareAt === 'number' ? rawCompareAt : parseFloat(rawCompareAt);
      // Heuristic: Shopify `/products/*.js` usually returns cents (>= 1000 for normal prices). If the number looks like whole cents keep it,
      // otherwise treat it as a decimal amount and convert to cents.
      const priceCents = numericPrice >= 1000
        ? Math.round(numericPrice)
        : Math.round(numericPrice * 100);
      total += priceCents * (item.quantity || 1);
    }

    return total > 0 ? String(total) : '';
  } catch (error) {
    console.warn('Failed to calculate bundle compare-at price', error);
    return '';
  }
}

function setButtonLoadingState(button, isLoading) {
  if (!button) {
    return;
  }
  button.disabled = isLoading;
  if (isLoading) {
    button.classList.add('is-loading');
  } else {
    button.classList.remove('is-loading');
  }
}

// Load product recommendations
function loadProductRecommendations(productId) {
  const recommendationsContainer = document.getElementById('recommendations');
  
  if (!recommendationsContainer) {
    return;
  }
  
  const dataElement = recommendationsContainer.querySelector('[data-product-id]');
  if (!dataElement) {
    return;
  }
  
  const limit = dataElement.getAttribute('data-limit') || 4;
  
  // Fetch recommendations from Shopify API
  fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`)
    .then(response => response.json())
    .then(data => {
      if (data.products && data.products.length > 0) {
        renderRecommendations(data.products, recommendationsContainer);
      } else {
        // Hide section if no recommendations
        const relatedSection = document.querySelector('.product-page__related');
        if (relatedSection) {
          relatedSection.style.display = 'none';
        }
      }
    })
    .catch(error => {
      console.error('Failed to load recommendations:', error);
      // Hide section on error
      const relatedSection = document.querySelector('.product-page__related');
      if (relatedSection) {
        relatedSection.style.display = 'none';
      }
    });
}

// Render product recommendations
function renderRecommendations(products, container) {
  // Clear loading placeholder
  container.innerHTML = '';
  
  products.forEach(product => {
    // Create product card element (simplified version)
    const productCard = document.createElement('article');
    productCard.className = 'collections__product';
    
    const productLink = document.createElement('a');
    productLink.href = product.url;
    productLink.className = 'collections__product-image-wrapper';
    
    const featuredImageSrc = product.featured_image;
    const hoverImageSrc = Array.isArray(product.images) && product.images.length > 1
      ? product.images[1].src || product.images[1]
      : null;

    if (featuredImageSrc) {
      const img = document.createElement('img');
      img.src = featuredImageSrc;
      img.alt = product.title;
      img.className = 'collections__product-image collections__product-image--default';
      img.loading = 'lazy';
      productLink.appendChild(img);
    }

    if (hoverImageSrc) {
      const hoverImg = document.createElement('img');
      hoverImg.src = hoverImageSrc;
      hoverImg.alt = product.title;
      hoverImg.className = 'collections__product-image collections__product-image--hover';
      hoverImg.loading = 'lazy';
      productLink.appendChild(hoverImg);
    }
    
    productCard.appendChild(productLink);
    
    const productInfo = document.createElement('div');
    productInfo.className = 'collections__product-info';
    
    const productTitle = document.createElement('h3');
    productTitle.className = 'collections__product-title';
    const titleLink = document.createElement('a');
    titleLink.className = 'collections__product-title-link';
    titleLink.href = product.url;
    titleLink.textContent = product.title;
    productTitle.appendChild(titleLink);
    productInfo.appendChild(productTitle);
    
  const priceWrapper = document.createElement('div');
  priceWrapper.className = 'collections__product-price-wrapper';

  // Add data attributes for global sale integration
  const trueOriginalPrice = (product.compare_at_price && product.compare_at_price > product.price)
    ? product.compare_at_price
    : product.price;
  priceWrapper.setAttribute('data-product-price-wrapper', '');
  priceWrapper.setAttribute('data-original-price', trueOriginalPrice);
  priceWrapper.setAttribute('data-current-price', product.price);

  const hasSale = product.compare_at_price && product.compare_at_price > product.price;
  if (hasSale) {
    const oldPrice = document.createElement('span');
    oldPrice.className = 'collections__product-price-old';
    oldPrice.setAttribute('data-original-price-display', '');
    oldPrice.textContent = formatMoney(product.compare_at_price);
    priceWrapper.appendChild(oldPrice);

    const price = document.createElement('p');
    price.className = 'collections__product-price collections__product-price--sale';
    price.setAttribute('data-sale-price-display', '');
    price.textContent = formatMoney(product.price);
    priceWrapper.appendChild(price);
  } else {
    const oldPrice = document.createElement('span');
    oldPrice.className = 'collections__product-price-old';
    oldPrice.setAttribute('data-original-price-display', '');
    oldPrice.style.display = 'none';
    oldPrice.textContent = formatMoney(product.price);
    priceWrapper.appendChild(oldPrice);

    const price = document.createElement('p');
    price.className = 'collections__product-price';
    price.setAttribute('data-current-price-display', '');
    price.textContent = formatMoney(product.price);
    priceWrapper.appendChild(price);
  }

  productInfo.appendChild(priceWrapper);
  productCard.appendChild(productInfo);

  container.appendChild(productCard);
  });

  // Apply global sale prices after rendering
  if (window.globalSale && window.globalSale.applyPrices) {
    window.globalSale.applyPrices();
  }
}

// Cart page initialization
function initCart() {
  const cartItems = document.querySelectorAll('[data-cart-item]');
  
  if (cartItems.length === 0) {
    return; // Not on cart page or cart is empty
  }
  
  // Render bundle breakdowns and sync inventory caps for bundle lines
  renderBundleBreakdowns().then((cart) => {
    syncBundleInventoryLimits(cart);
  });
  
  // Initialize quantity controls
  initCartQuantityControls();
  
  // Initialize delete buttons
  initCartDeleteButtons();
  
  // Initial check for inventory limits
  updateInventoryButtons();
}

// Show cart error popup
function showCartError(message) {
  // Remove existing popup
  const existingPopup = document.querySelector('.cart-error-popup');
  if (existingPopup) {
    existingPopup.remove();
  }
  
  // Create popup
  const popup = document.createElement('div');
  popup.className = 'cart-error-popup';
  popup.setAttribute('role', 'alert');
  
  popup.innerHTML = `
    <div class="cart-error-popup__icon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="16" r="1" fill="currentColor"/>
      </svg>
    </div>
    <div class="cart-error-popup__message">${message}</div>
  `;
  
  document.body.appendChild(popup);
  
  // Show with animation
  requestAnimationFrame(() => {
    popup.classList.add('cart-error-popup--visible');
  });
  
  // Hide after 3 seconds
  setTimeout(() => {
    popup.classList.remove('cart-error-popup--visible');
    setTimeout(() => {
      popup.remove();
    }, 300);
  }, 4000);
}

// Check inventory limits and update buttons state
function updateInventoryButtons() {
  const wrappers = document.querySelectorAll('.cart-item__quantity-wrapper');
  
  wrappers.forEach(wrapper => {
    const increaseBtn = wrapper.querySelector('[data-quantity-increase]');
    const quantityValue = parseInt(wrapper.querySelector('[data-quantity-value]').textContent) || 0;
    const maxInventory = parseInt(wrapper.dataset.inventoryMax) || 9999;
    
    if (increaseBtn) {
      if (quantityValue >= maxInventory) {
        increaseBtn.disabled = true;
        increaseBtn.style.opacity = '0.5';
        increaseBtn.style.cursor = 'not-allowed';
      } else {
        increaseBtn.disabled = false;
        increaseBtn.style.opacity = '';
        increaseBtn.style.cursor = '';
      }
    }
  });
}

// Render bundle breakdowns from line item properties to ensure we show the selected items
async function renderBundleBreakdowns() {
  try {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) {
      return null;
    }
    const cart = await response.json();
    if (!cart.items || !cart.items.length) {
      return cart;
    }

    cart.items.forEach((item) => {
      const bundleRaw = item.properties && item.properties._bundle_items;
      if (!bundleRaw) {
        return;
      }

      let bundleItems;
      try {
        bundleItems = JSON.parse(bundleRaw);
      } catch (e) {
        console.warn('Failed to parse bundle items', e);
        return;
      }
      if (!Array.isArray(bundleItems) || !bundleItems.length) {
        return;
      }

      const lineKey = item.key;
      const container = document.querySelector(
        `[data-cart-item][data-line-key="${lineKey}"] .bundle-breakdown__items`
      );
      if (!container) {
        return;
      }

      container.innerHTML = '';

      bundleItems.forEach((bundleLine) => {
        const title =
          bundleLine.productTitle ||
          bundleLine.title ||
          item.product_title ||
          item.title ||
          '';
        const color = bundleLine.color;
        const size = bundleLine.size;
        const imageUrl = bundleLine.imageUrl;

        const itemDiv = document.createElement('div');
        itemDiv.className = 'bundle-breakdown__item';

        if (imageUrl) {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = title;
          img.className = 'bundle-breakdown__item-image';
          img.loading = 'lazy';
          itemDiv.appendChild(img);
        } else {
          const placeholder = document.createElement('div');
          placeholder.className = 'bundle-breakdown__placeholder';
          placeholder.textContent = title ? title.slice(0, 1) : '?';
          itemDiv.appendChild(placeholder);
        }

        const info = document.createElement('div');
        info.className = 'bundle-breakdown__item-info';

        const titleEl = document.createElement('p');
        titleEl.className = 'bundle-breakdown__item-title';
        titleEl.textContent = title;
        info.appendChild(titleEl);

        const variantEl = document.createElement('p');
        variantEl.className = 'bundle-breakdown__item-variant';
        if (color) {
          const colorSpan = document.createElement('span');
          colorSpan.textContent = `${window.themeStrings?.cartColorLabel || 'Color'}: ${capitalize(color)}`;
          variantEl.appendChild(colorSpan);
        }
        if (size) {
          const sizeSpan = document.createElement('span');
          sizeSpan.textContent = `${window.themeStrings?.cartSizeLabel || 'Size'}: ${size}`;
          variantEl.appendChild(sizeSpan);
        }
        info.appendChild(variantEl);

        itemDiv.appendChild(info);
        container.appendChild(itemDiv);
      });
    });
    return cart;
  } catch (error) {
    console.error('Failed to render bundle breakdowns:', error);
    return null;
  }
}

function capitalize(value) {
  if (!value || typeof value !== 'string') return value;
  return value.charAt(0).toUpperCase() + value.slice(1);
}

// Synchronize bundle line max quantity with available stock of bundled variants
async function syncBundleInventoryLimits(cartData) {
  try {
    const cart = cartData || (await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : null)));
    if (!cart || !cart.items) return;

    const productCache = new Map();

    for (const item of cart.items) {
      const bundleRaw = item.properties && item.properties._bundle_items;
      if (!bundleRaw) continue;

      let bundleItems;
      try {
        bundleItems = JSON.parse(bundleRaw);
      } catch (e) {
        continue;
      }
      if (!Array.isArray(bundleItems) || !bundleItems.length) continue;

      let minAvailable = Infinity;

      for (const bItem of bundleItems) {
        const handle = bItem.handle;
        const variantIdRaw = bItem.variantId || bItem.variant_id;
        if (!handle || !variantIdRaw) continue;

        // Fetch product data once per handle
        if (!productCache.has(handle)) {
          const productResp = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
          if (!productResp.ok) {
            productCache.set(handle, null);
          } else {
            productCache.set(handle, await productResp.json());
          }
        }
        const productData = productCache.get(handle);
        if (!productData || !productData.variants) continue;

        const numericVariantId = parseInt(String(variantIdRaw).replace(/\D/g, ''), 10);
        const variant = productData.variants.find((v) => v.id === numericVariantId);
        if (!variant) continue;

        // If inventory is not managed, treat as unlimited
        if (variant.inventory_management && variant.inventory_policy === 'deny') {
          const available = typeof variant.inventory_quantity === 'number' ? variant.inventory_quantity : Infinity;
          if (available < minAvailable) {
            minAvailable = available;
          }
        }
      }

      if (minAvailable !== Infinity) {
        const qtyWrapper = document.querySelector(
          `[data-cart-item][data-line-key="${item.key}"] .cart-item__quantity-wrapper`
        );
        if (qtyWrapper) {
          qtyWrapper.dataset.inventoryMax = String(minAvailable);
        }
      }
    }

    updateInventoryButtons();
  } catch (error) {
    console.error('Failed to sync bundle inventory limits:', error);
  }
}

// Cart quantity controls
function initCartQuantityControls() {
  const increaseButtons = document.querySelectorAll('[data-quantity-increase]');
  const decreaseButtons = document.querySelectorAll('[data-quantity-decrease]');
  
  // Increase quantity
  increaseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const lineIndex = this.getAttribute('data-line-index');
      const lineKey = this.getAttribute('data-line-key');
      const cartItem = this.closest('[data-cart-item]');
      const quantityElement = cartItem.querySelector('[data-quantity-value]');
      
      // Check inventory limit before sending request
      const wrapper = this.closest('.cart-item__quantity-wrapper');
      const maxInventory = parseInt(wrapper.dataset.inventoryMax) || 9999;
      const currentQty = parseInt(quantityElement.textContent) || 0;
      
      if (currentQty >= maxInventory) {
        return; // Do not allow increase
      }
      
      if (quantityElement) {
        const currentQuantity = parseInt(quantityElement.textContent) || 1;
        const newQuantity = currentQuantity + 1;
        
        updateCartQuantity(lineIndex, lineKey, newQuantity, quantityElement, cartItem);
      }
    });
  });
  
  // Decrease quantity
  decreaseButtons.forEach(button => {
    button.addEventListener('click', function() {
      const lineIndex = this.getAttribute('data-line-index');
      const lineKey = this.getAttribute('data-line-key');
      const cartItem = this.closest('[data-cart-item]');
      const quantityElement = cartItem.querySelector('[data-quantity-value]');
      
      if (quantityElement) {
        const currentQuantity = parseInt(quantityElement.textContent) || 1;
        const newQuantity = Math.max(1, currentQuantity - 1);
        
        if (newQuantity >= 1) {
          updateCartQuantity(lineIndex, lineKey, newQuantity, quantityElement, cartItem);
        }
      }
    });
  });
}

// Update cart quantity via AJAX
function updateCartQuantity(lineIndex, lineKey, newQuantity, quantityElement, cartItem) {
  // Disable buttons during update
  const buttons = cartItem.querySelectorAll('.cart-item__quantity-btn');
  buttons.forEach(btn => btn.disabled = true);
  
  // Show loading state
  quantityElement.style.opacity = '0.5';
  
  // Send update request
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: newQuantity
    })
  })
  .then(response => response.json().then(data => ({ response, data })))
  .then(({ response, data }) => {
    if (!response.ok) {
      throw new Error(data.message || data.description || 'Error updating cart');
    }

    // Update quantity in DOM
    quantityElement.textContent = newQuantity;
    
    // Find the updated item in the response
    // items array is 0-indexed, so line 1 corresponds to index 0
    const updatedItem = data.items[parseInt(lineIndex, 10) - 1];
    
    if (updatedItem) {
      // Update line price
      const linePriceElement = cartItem.querySelector('[data-line-price]');
      if (linePriceElement) {
        linePriceElement.textContent = formatMoney(updatedItem.final_line_price);
      }
    }
    
    // Update cart total
    updateCartTotal(data.total_price);
    
    // Re-enable buttons
    buttons.forEach(btn => btn.disabled = false);
    quantityElement.style.opacity = '1';
    
    // Update inventory buttons state
    updateInventoryButtons();
  })
  .catch(error => {
    console.error('Error updating cart:', error);
    
    // Show error popup
    showCartError(error.message || 'Error updating cart. Please try again.');
    
    // Re-enable buttons
    buttons.forEach(btn => btn.disabled = false);
    quantityElement.style.opacity = '1';
    
    // Update inventory buttons state
    updateInventoryButtons();
  });
}

// Update cart total in summary
function updateCartTotal(totalPrice) {
  const cartTotalPriceElement = document.querySelector('[data-cart-total-price]');
  
  if (cartTotalPriceElement) {
    const formattedPrice = formatMoney(totalPrice);
    cartTotalPriceElement.textContent = formattedPrice;
  }
  }
  
  // Cart delete buttons
  function initCartDeleteButtons() {
    const deleteButtons = document.querySelectorAll('[data-cart-remove]');
  
  deleteButtons.forEach(button => {
    button.addEventListener('click', function() {
      const lineIndex = this.getAttribute('data-line-index');
      const lineKey = this.getAttribute('data-line-key');
      const cartItem = this.closest('[data-cart-item]');
      if (!cartItem) return;
      
      // Capture item info for undo
      const variantId = this.getAttribute('data-variant-id');
      const quantity = parseInt(this.getAttribute('data-quantity') || '1', 10) || 1;
      const propertiesRaw = this.getAttribute('data-properties') || '{}';
      let properties = {};
      try {
        properties = JSON.parse(propertiesRaw);
      } catch (e) {
        properties = {};
      }
      const sellingPlanId = this.getAttribute('data-selling-plan-id') || '';
      const itemTitle = cartItem.querySelector('.cart-item__title')?.textContent?.trim() || '';
      
      removeCartItem(lineIndex, lineKey, cartItem, {
        variantId,
        quantity,
        properties,
        sellingPlanId,
        title: itemTitle
      });
    });
  });
  }
  
  // Remove cart item via AJAX
  function removeCartItem(lineIndex, lineKey, cartItem, undoPayload) {
    // Disable delete button
    const deleteButton = cartItem.querySelector('[data-cart-remove]');
    if (deleteButton) {
      deleteButton.disabled = true;
    }
  
  // Add removing animation
  cartItem.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
  cartItem.style.opacity = '0';
  cartItem.style.transform = 'translateX(-20px)';
  
  // Send remove request
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: String(lineKey),
      quantity: 0
    })
  })
    .then(response => response.json().then(data => ({ response, data })))
    .then(({ response, data }) => {
      if (!response.ok) {
        throw new Error(data.message || data.description || 'Error removing item');
      }

    // Remove item from DOM after animation
    setTimeout(() => {
      cartItem.remove();
      
      // Update cart total
      updateCartTotal(data.total_price);
      
      // If cart is empty, reload page to show empty state
      if (data.item_count === 0) {
        window.location.reload();
      }
      
      // Show undo toast
      if (undoPayload && undoPayload.variantId) {
        showCartUndoToast(undoPayload);
      }
    }, 300);
  })
  .catch(error => {
    console.error('Error removing item:', error);
    
    // Restore item on error
    cartItem.style.opacity = '1';
    cartItem.style.transform = 'translateX(0)';
    
    if (deleteButton) {
      deleteButton.disabled = false;
    }
    
    const message = (document.body && document.body.dataset.alertRemoveError) || 'Error removing item. Please try again.';
    alert(message);
  });
  }

  function ensureCartToastStyles() {
    if (document.getElementById('cart-toast-styles')) return;
    const style = document.createElement('style');
    style.id = 'cart-toast-styles';
    style.textContent = `
      .cart-toast {
        position: fixed;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        background: #1a1a1a;
        color: #fff;
        padding: 12px 16px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        display: flex;
        align-items: center;
        gap: 12px;
        z-index: 9999;
        max-width: 90%;
        font-size: 14px;
      }
      .cart-toast__message { flex: 1; }
      .cart-toast__undo {
        background: #ffd26e;
        color: #1a1a1a;
        border: none;
        padding: 8px 12px;
        border-radius: 6px;
        cursor: pointer;
        font-weight: 600;
      }
      .cart-toast__undo:hover { background: #ffce5a; }
    `;
    document.head.appendChild(style);
  }

  let cartUndoTimeout = null;
  let cartToastElement = null;

  function showCartUndoToast(undoPayload) {
    ensureCartToastStyles();
    if (cartToastElement) {
      cartToastElement.remove();
      cartToastElement = null;
    }
    if (cartUndoTimeout) {
      clearTimeout(cartUndoTimeout);
      cartUndoTimeout = null;
    }
    
    const toast = document.createElement('div');
    toast.className = 'cart-toast';
    
    const removedLabel =
      document.body.getAttribute('data-cart-item-removed') ||
      'Item removed';
    const undoLabel =
      document.body.getAttribute('data-cart-undo') ||
      'Undo';

    const message = document.createElement('div');
    message.className = 'cart-toast__message';
    if (undoPayload.title) {
      message.textContent = `${undoPayload.title} — ${removedLabel}`;
    } else {
      message.textContent = removedLabel;
    }
    
    const undoButton = document.createElement('button');
    undoButton.className = 'cart-toast__undo';
    undoButton.type = 'button';
    undoButton.textContent = undoLabel;
    undoButton.addEventListener('click', () => {
      if (cartUndoTimeout) {
        clearTimeout(cartUndoTimeout);
        cartUndoTimeout = null;
      }
      toast.remove();
      cartToastElement = null;
      restoreRemovedCartItem(undoPayload);
    });
    
    toast.appendChild(message);
    toast.appendChild(undoButton);
    document.body.appendChild(toast);
    cartToastElement = toast;
    
    cartUndoTimeout = setTimeout(() => {
      toast.remove();
      cartToastElement = null;
      cartUndoTimeout = null;
    }, 8000);
  }

  function restoreRemovedCartItem(payload) {
    if (!payload || !payload.variantId) return;
    const body = {
      id: String(payload.variantId),
      quantity: payload.quantity || 1
    };
    if (payload.properties && Object.keys(payload.properties).length > 0) {
      body.properties = payload.properties;
    }
    if (payload.sellingPlanId) {
      body.selling_plan = payload.sellingPlanId;
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(res => res.json().then(data => ({ res, data })))
    .then(({ res, data }) => {
      if (!res.ok) {
        throw new Error(data?.description || data?.message || 'Failed to restore item');
      }
      window.location.reload();
    })
  .catch((error) => {
    console.error('Failed to restore item:', error);
    const message = (document.body && document.body.dataset.alertRestoreError) || 'Failed to restore item. Please try again.';
    alert(message);
  });
}

/* ============================================
   Contact Form AJAX Handler
   ============================================ */

function getContactFormElement() {
  return document.getElementById('contact-form') || document.getElementById('contact_form');
}

function initContactForm() {
  const contactForm = getContactFormElement();
  
  if (!contactForm) {
    return;
  }

  // Let Shopify handle the form natively to avoid double submits / 400s
  return;
  
  contactForm.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const submitButton = contactForm.querySelector('.pages-page__submit-btn');
    const originalButtonText = submitButton ? submitButton.textContent : '';
    
    // Disable submit button and show loading state
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = '...';
    }
    
    // Remove any existing messages
    const existingMessages = contactForm.querySelectorAll('.pages-page__form-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Get form data
    const formData = new FormData(contactForm);
    
    // Submit form via fetch
    fetch(contactForm.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Form submission failed');
      }
    })
    .then(html => {
      // Parse the response to check for success
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const formInResponse = doc.querySelector('#contact-form');
      
      // Check if the form has errors (if there are error messages in response)
      const hasErrors = formInResponse && formInResponse.querySelector('.pages-page__form-message--error');
      
      if (hasErrors) {
        // Extract and display error messages
        const errorMessage = formInResponse.querySelector('.pages-page__form-message--error');
        if (errorMessage) {
          contactForm.insertAdjacentElement('afterbegin', errorMessage.cloneNode(true));
        }
      } else {
        // Success - show success message and reset form
        const successMessage = document.createElement('div');
        successMessage.className = 'pages-page__form-message pages-page__form-message--success';
        successMessage.setAttribute('role', 'status');
        successMessage.textContent = contactForm.getAttribute('data-success-message') || 'Thank you! Your message has been sent.';
        
        contactForm.insertAdjacentElement('afterbegin', successMessage);
        
        // Reset form fields
        contactForm.reset();
        
        // Scroll to success message
        successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    })
    .catch(error => {
      console.error('Form submission error:', error);
      
      // Show generic error message
      const errorMessage = document.createElement('div');
      errorMessage.className = 'pages-page__form-message pages-page__form-message--error';
      errorMessage.setAttribute('role', 'alert');
      errorMessage.textContent = 'An error occurred. Please try again.';
      
      contactForm.insertAdjacentElement('afterbegin', errorMessage);
    })
    .finally(() => {
      // Re-enable submit button
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
    });
  });
}

// Initialize contact form on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForm);
} else {
  initContactForm();
}

// Contact form success redirect
function initContactSuccessRedirect() {
  const contactForm = getContactFormElement();
  if (!contactForm) return;

  const params = new URLSearchParams(window.location.search);
  const posted = params.get('contact_posted');
  const redirectUrl = contactForm.dataset.contactSuccessRedirect;
  if (posted === 'true' && redirectUrl) {
    window.location.replace(redirectUrl);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactSuccessRedirect);
} else {
  initContactSuccessRedirect();
}

// Contact form success popup (when server rendered success state)
function initContactSuccessPopup() {
  const contactForm = getContactFormElement();
  if (!contactForm) return;

  const successMessage = contactForm.querySelector('.pages-page__form-message--success');
  if (!successMessage) return;

  if (document.getElementById('contact-success-popup')) return;

  const popup = document.createElement('div');
  popup.id = 'contact-success-popup';
  popup.className = 'contact-popup';
  popup.setAttribute('role', 'dialog');
  popup.setAttribute('aria-modal', 'true');

  const popupContent = document.createElement('div');
  popupContent.className = 'contact-popup__content';

  const title = document.createElement('p');
  title.className = 'contact-popup__title';
  title.textContent = successMessage.textContent.trim() || contactForm.getAttribute('data-success-message') || 'Message sent';

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'contact-popup__close';
  closeBtn.setAttribute('aria-label', 'Close');
  closeBtn.textContent = '×';

  const actions = document.createElement('div');
  actions.className = 'contact-popup__actions';
  const okBtn = document.createElement('button');
  okBtn.type = 'button';
  okBtn.className = 'contact-popup__button';
  okBtn.textContent = 'OK';

  const dismiss = () => popup.remove();
  closeBtn.addEventListener('click', dismiss);
  okBtn.addEventListener('click', dismiss);

  actions.appendChild(okBtn);
  popupContent.appendChild(closeBtn);
  popupContent.appendChild(title);
  popupContent.appendChild(actions);
  popup.appendChild(popupContent);
  document.body.appendChild(popup);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactSuccessPopup);
} else {
  initContactSuccessPopup();
}
